import { AuthConsumerRenderProps, withAuthContext } from 'auth/AuthContext';
import { CancelTokenSource } from 'axios';
import AddActionButton from 'components/AddActionButton';
import DeleteActionButton from 'components/DeleteActionButton';
import EditActionButton from 'components/EditActionButton';
import { CheckboxSc } from 'components/final-form/CheckBox';
import FullScreenLightBox from 'components/image/FullScreenLightBox';
import InvoiceActionButton from 'components/InvoiceActionButton';
import FormModalContentContainer, { ModalContentContainerSc } from 'components/layout/FormModalContentContainer';
import PxGrid from 'components/layout/PxGrid';
import StyledErrorMessage from 'components/layout/StyledErrorMessage';
import VirtualizedTable, { ExtendedColumnProps } from 'components/layout/VirtualizedTable';
import LoaderComponent from 'components/LoaderComponent';
import { MandateConsumerRenderProps, withMandateContext } from 'components/MandateContext';
import BookingHistoryView from 'components/patient-entry/BookingHistoryView';
import ChangeEmployeeEmailModal from 'components/patient-entry/bookings-table/ChangeEmployeeEmailModal';
import InterventionInfoView from 'components/patient-entry/bookings-table/InterventionInfoView';
import PatientInfoPopUpView from 'components/patient-entry/bookings-table/PatientInfoPopUpView';
import PatientInfoView from 'components/patient-entry/bookings-table/PatientInfoView';
import PoolTestkitOverview from 'components/patient-entry/bookings-table/PoolTestkitOverview';
import PoolTestkitSingularization from 'components/patient-entry/bookings-table/PoolTestkitSingularization';
import ResendTestResultEmailActionButton
  from 'components/patient-entry/bookings-table/ResendTestResultEmailActionButton';
import SetControlledByStatusActionButton
  from 'components/patient-entry/bookings-table/SetControlledByStatusActionButton';
import SetQuestionTestResultModal from 'components/patient-entry/bookings-table/SetQuestionTestResultModal';
import SetTestPanelResultModal from 'components/patient-entry/bookings-table/SetTestPanelResultModal';
import SetTestResultModal from 'components/patient-entry/bookings-table/SetTestResultModal';
import TestResultActionButton from 'components/patient-entry/bookings-table/TestResultActionButton';
import TestTransitionForm from 'components/patient-entry/bookings-table/TestTransitionForm';
import VaccinationTransitionForm from 'components/patient-entry/bookings-table/VaccinationTransitionForm';
import {
  InterventionBookings,
  InterventionBookingSearchRow,
  isBookingSelectable,
  isTestInterventionSelectable
} from 'components/patient-entry/PatientCentral';
import {
  PatientCentralConsumerRenderProps,
  withPatientCentralContext
} from 'components/patient-entry/PatientCentralContext';
import {
  PatientCentralRefDataConsumerRenderProps,
  withPatientCentralRefDataContext
} from 'components/patient-entry/PatientCentralRefDataContext';
import QuestionSetView from 'components/patient-entry/QuestionSetView';
import AddTestkitCodeModal from 'components/patient-entry/upsert/AddTestkitCodeModal';
import PdfModal from 'components/pdf-modal/PdfModal';
import QrcodeActionButton from 'components/QrcodeActionButton';
import _ from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import { MessageSourceProps, withMessages } from 'react-message-source';
import { RouteComponentProps } from 'react-router';
import { Button, Grid, Icon, Loader, Message, Modal, Popup, SemanticCOLORS, SemanticICONS } from 'semantic-ui-react';
import { getPdfUrl } from 'services/documentServices';
import axios from 'services/http';
import {
  checkInOutVaccinationBooking,
  deleteInterventionBookingInvoice,
  getDefaultTestParametersForEmployee,
  getDetailedPoolTestKits,
  getInterventionBookingAnswers,
  getInterventionBookingHistory,
  getTestResultImage,
  invoiceInterventionBooking,
  resendTestResultEmail,
  revertBookingStatusBeforeOnHold,
  setBookingStatusOnHold,
  updateBookingStatus
} from 'services/interventionBookingServices';
import { getInterventionPrice } from 'services/interventionPriceServices';
import { getPdfImageUrl, getVaccinationCertificateForBooking } from 'services/patientRecordServices';
import {
  fastPrintPatientDocuments,
  getPatientForPatientCentral,
  vaccinationCardDocument
} from 'services/patientServices';
import { createCovidTestkitQrcodeBase64String, createPanelTestkitQrcodeBase64String } from 'services/testkitServices';
import styled from 'styled-components';
import {
  AnamnesisSeverity,
  InterventionBookingSearchBy,
  InterventionBookingStatus,
  InterventionBookingTestResult,
  InterventionExternalCode,
  Privilege,
  TestDateSearchBy,
  Urgency,
  VerifyEmailStatus
} from 'ts-types/api.enums';
import {
  CompleteVaccinationBookingRequestDto,
  EmployeeDefaultParameters,
  EmployeeTestResultImagePdfDto,
  InterventionBookingHistoryDto,
  InterventionBookingSearchResult,
  InterventionDto,
  InterventionTestBookingSearchResult,
  ObjectValidationErrorDto,
  PatientInfoDto,
  PdfResponse,
  PoolTestkitOverviewResponseDto,
  PraxTestRegistrationQrCodeRequest,
  ProductDto,
  QuestionAnswerDto,
  QuestionSetDto,
  ResourceDto,
  VaccinationCheckInOutResponse,
  VerifyTestResultsInterventionResponse
} from 'ts-types/api.types';
import { ChromeExtensionStatus, getChromeExtensionStatus, getPrinters, printDocument } from 'utils/chomeExtensionUtils';
import { isoToDisplayDate, toIsoDateString } from 'utils/dateUtils';
import { errorUtils } from 'utils/errorUtils';
import { isLabTest, isTestKitCodeOptional, isTestPanel } from 'utils/interventionUtils';
import { withRouterWorkaround } from 'utils/workaroundUtils';

const TableDiv = styled.div`
  flex: 1 1 auto;
  padding: 0.5rem;
  background: white;

  .icon-div {
    display: inline-flex;
    padding-right: 5px;
    vertical-align: text-top;
  }

  .intervention-icon-div {
    display: inline-flex;
  }

  .text-div {
    display: inline;
    vertical-align: super;
  }
`;

const QrContentDiv = styled.div`

  min-height: 320px;
  padding: 0.2rem;

  .employee-data {
    font-size: 1.1rem;
    font-weight: 500;
    margin: 0 0 0.75rem 0.2rem;
    white-space: nowrap;
  }

  .qrcode-wrapper {
    display: inline-block;
    border: 1px solid #e5e5e5;
    padding: 1rem;
    margin-bottom: 0.5rem;

    .qrcode {
      background-size: contain;
      width: 140px;
      height: 140px;
    }
  }

  .actions-row {
    margin: 0.75rem 0;

    .ui.button {
      border-radius: unset;
    }
  }

  .link-info {
    color: #407A8C;
    margin: 0.75rem 0.1rem 0;
    padding-top: 0.5rem;
    border-top: 1px solid #e5e5e5;
  }
`;

export const StyledTable = styled(VirtualizedTable)`
  .ReactVirtualized__Table__Grid {
    outline: none;
    border: 1px solid rgba(34, 36, 38, .15);
    border-top: none;
    border-radius: 0 0 .28571429rem .28571429rem;
  }

  .ReactVirtualized__Table__row {
    border-left: none;
  }

  .ReactVirtualized__Table__headerColumn {
    height: 100%;
    border-right: 1px solid rgba(34, 36, 38, .15);
    padding-top: 0.85rem;
  }

  .ReactVirtualized__Table__headerColumn:last-child {
    border-right: none;
  }

  .ReactVirtualized__Table__rowColumn {
    height: 100%;
    border-right: 1px solid rgba(34, 36, 38, .15);
    padding-top: 0.85rem;
  }

  .ReactVirtualized__Table__rowColumn:last-child {
    border-right: none;
  }

  & .evenRow:hover, .oddRow:hover {
    background: rgba(0, 0, 0, .05);
  }

  .id-icon {
    margin-left: 0.35rem;
  }

  .text-id-icon {
    margin-left: 0.35rem;
    color: #999;
    font-weight: bold;
    font-family: Arial, sans-serif;
    font-size: 1rem;
  }

  .anamnesis-severity-icon {
    padding-right: 0.2rem;
  }

  .anamnesis-details-icon {
    padding-left: 0.35rem;
  }

  .status-icon {
    padding-right: 0.3rem;
  }

  .booking-history-icon-container {
    display: inline-block;
    vertical-align: top;
  }

  .booking-history-icon {
    padding-left: 0.5rem;
  }

  .intervention-booking-status-container {
    display: inline-block;

    .intervention-booking-status {
      max-width: 90px;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }

  .intervention-booking-status.status-PLANNED {
    //color: #1e70bf;
    color: #7d7d7d;
  }

  .intervention-booking-status.status-COMPLETED {
    color: green;
  }

  .intervention-booking-status.status-CANCELLED {
    color: darkred;
  }

  .intervention-booking-status.status-ON_WAIT_LIST {
    color: #b3a338;
  }

  .authority-notification-status.status-NA {
    //color: #1e70bf;
    color: #7d7d7d;
  }

  .authority-notification-status.status-NOTIFIED {
    color: green;
  }

  .date.disabled {
    color: #909090;
  }

  .expected-date {
    display: inline-block;
  }

  .expected-date.warn {
    color: #a76f0b;
  }

  .expected-date.overdue {
    color: darkred;
  }

  .anonymous-stripes {
    height: 19px;
    width: 93%;
    -webkit-background-size: 6px 6px;
    -moz-background-size: 6px 6px;
    background-size: 6px 6px;
  }

  .deg45 {
    background-color: white;
    background-image: -webkit-gradient(linear, 0 0, 100% 100%, color-stop(.25, gray), color-stop(.25, transparent), color-stop(.5, transparent), color-stop(.5, gray), color-stop(.75, gray), color-stop(.75, transparent), to(transparent));
    background-image: -webkit-linear-gradient(-45deg, gray 25%, transparent 25%, transparent 50%, gray 50%, gray 75%, transparent 75%, transparent);
    background-image: -moz-linear-gradient(-45deg, gray 25%, transparent 25%, transparent 50%, gray 50%, gray 75%, transparent 75%, transparent);
    background-image: -ms-linear-gradient(-45deg, gray 25%, transparent 25%, transparent 50%, gray 50%, gray 75%, transparent 75%, transparent);
    background-image: -o-linear-gradient(-45deg, gray 25%, transparent 25%, transparent 50%, gray 50%, gray 75%, transparent 75%, transparent);
    background-image: linear-gradient(-45deg, gray 25%, transparent 25%, transparent 50%, gray 50%, gray 75%, transparent 75%, transparent);
  }
`;

const NoDataDiv = styled.div`
  font-size: 1rem;
  color: #444;
  font-style: italic;
  padding: 0.7rem 1rem;
`;

const InfoDiv = styled.div`
  & .info-message {
    margin-top: 2rem;
    min-height: 105px;
  }

  & .info-message .download-link {
    margin-top: 1.5rem;
  }

  & .actions .button:first-child {
    margin-left: 0;
  }
`;

const StyledPxGrid = styled(PxGrid)`
  &.ui.grid > .row > .column {
    padding-left: 0;
    padding-right: 0;
  }

  &.ui.grid > .row > .column.with-line-break {
    white-space: pre-wrap;
  }
`;

export const StateTransitionDiv = styled.div`

  min-width: 13rem;

  .info {
    margin-bottom: 0.7rem;
    padding: 0.5rem 0.65rem 0;
    font-size: 1.05rem;
  }

  .cancel-box {
    border-top: 1px solid #eaeaea;
    margin-top: 0.5rem;
    padding-top: 0.5rem;
  }

  & .ui.basic.button {
    display: block;
    padding: 0.5rem;
    border: none;
    box-shadow: none !important;
    white-space: nowrap;

    color: #707070 !important;

    & > .right.icon:not(.button):not(.dropdown) {
      margin: 0 .42857143em 0 -.21428571em;
    }

    &:HOVER {
      color: #454545 !important;
    }

    &.most-likely-next-state {
      color: #0b548a !important;

      &:HOVER {
        color: #0B548A !important;
      }
    }

    &.cancel-button {
      color: darkred !important;

      &:HOVER {
        color: #b51111 !important;
      }
    }
  }
`;

const StyledErrorContainer = styled.h4`
  color: #8a7305;
`;

const StyledButton = styled(Button)`
  &.ui.inverted.button.styled-button {
    box-shadow: none !important;
    opacity: 0.7;
  }

  &.ui.inverted.button:hover,
  &.ui.inverted.button:active,
  &.ui.inverted.button:focus {
    opacity: 1;
    color: #FFFFFF !important;
    background-color: transparent !important;
  }
`;

export const ANAMNESIS_SEVERITY_COLORS: { [id: string]: SemanticCOLORS } = {
  [AnamnesisSeverity.VERY_LOW]: "grey",
  [AnamnesisSeverity.LOW]: "blue",
  [AnamnesisSeverity.MEDIUM]: "yellow",
  [AnamnesisSeverity.HIGH]: "orange",
  [AnamnesisSeverity.VERY_HIGH]: "red"
};

interface Props extends PatientCentralConsumerRenderProps,
    PatientCentralRefDataConsumerRenderProps,
    MessageSourceProps,
    AuthConsumerRenderProps,
    RouteComponentProps,
    MandateConsumerRenderProps {

  bookings: InterventionBookings,
  bookingsLoading: boolean,
  verifyTestResultsResponse: VerifyTestResultsInterventionResponse
  selectedInterventionBookings: Set<number>,
  selectedTestInterventionBookings: Set<number>,
  onEditBooking: (id: number) => void,
  onAddNewChildBooking: (parentBookingId: number) => void,
  onInvoiceBookingDone: (bookingId: number) => void,
  onUpdateBookingStatus: (bookingId?: number, status?: InterventionBookingStatus) => void,
  onUpdateBookingTestResult: (bookingId: number) => void,
  onClearBookingTestResult: (bookingId: number) => void,
  onUpdateBookingSelection: (bookingId: number, selection: boolean, isTestSearch: boolean) => void,
  onUpdateBookings: (bookingIds: Set<number>, isTestSearch: boolean) => void,
  onRefreshBooking: (bookingId: number) => void
}

interface State {
  questionAnswerPairs: Array<QuestionAnswerDto>,
  questionAnswerPairsLoading: boolean,
  interventionBookingHistory: Array<InterventionBookingHistoryDto>,
  interventionBookingHistoryLoading: boolean,
  poolTestkitOverviewData: Partial<PoolTestkitOverviewResponseDto>,
  poolTestkitOverviewLoading: boolean,
  patientInfo?: PatientInfoDto,
  patientInfoLoading: boolean,
  resultImage?: EmployeeTestResultImagePdfDto;
  resultImageLoading: boolean;

  interventionInfoLoading: boolean;
  productId?: string;
  invoiceProduct?: ProductDto;
  employeeDefaultParameters?: EmployeeDefaultParameters,
  interventionPriceInsurance?: number;
  interventionPricePatient?: number;

  errorMessages: Array<string>;
  testkitRegistrationBookingId?: number;

  testkitSetResultBooking?: InterventionTestBookingSearchResult;
  testkitSetResultModalOpen: boolean;
  testkitSetHpvResultModalOpen: boolean;
  testkitSetQuestionsResultModalOpen: boolean;

  printLabelPopupOpen: boolean;
  printLabelPopupStatus: string;

  statusChangePopupOpen?: number;
  stateVaccinationTransitionModalOpen: boolean;
  stateTestTransitionModalOpen: boolean;
  bookingInTransition?: InterventionBookingSearchRow;
  addTestkitCodeModalOpen: boolean;

  qrcodeb64?: string,
  testRegistrationUrl?: string,
  qrcodeVisible: boolean;

  poolSingularizationModalOpen: boolean;
  poolSingularizationId?: number;

  vaccinationCardPdfModalOpen: boolean,
  vaccinationCertPdfModalOpen: boolean,
  vaccinationDocuments?: PdfResponse[],

  generateVaccinationCertificateError?: ObjectValidationErrorDto,

  patientInfoPopupBookingId?: number,
  changeEmployeeMailPatientId?: number,

  resendTestResultEmail?: boolean,

  cancelTokenSource: CancelTokenSource,
}

class InterventionBookingsTableView extends Component<Props, State> {

  questionSetMap: { [id: number]: QuestionSetDto } = {};

  interventionBookingHistoryMap: { [id: number]: InterventionDto } = {};

  interventionMap: { [id: number]: InterventionDto } = {};

  resourceMap: { [id: number]: ResourceDto } = {};

  initialPoolTestkitOverview: Partial<PoolTestkitOverviewResponseDto> = {
    poolTestkitCode: "",
    poolTestkitOverview: []
  }

  constructor(props: Props) {
    super(props);

    const {options: {workDate}} = this.props;

    const cancelTokenSource = axios.CancelToken.source();

    this.state = {
      questionAnswerPairs: [],
      questionAnswerPairsLoading: false,
      interventionBookingHistory: [],
      interventionBookingHistoryLoading: false,
      poolTestkitOverviewData: this.initialPoolTestkitOverview,
      poolTestkitOverviewLoading: false,
      patientInfoLoading: false,
      resultImageLoading: false,
      interventionInfoLoading: false,
      errorMessages: [],

      addTestkitCodeModalOpen: false,
      qrcodeVisible: false,
      poolSingularizationModalOpen: false,

      testkitSetResultModalOpen: false,
      testkitSetHpvResultModalOpen: false,
      testkitSetQuestionsResultModalOpen: false,

      printLabelPopupOpen: false,
      printLabelPopupStatus: "none",

      stateVaccinationTransitionModalOpen: false,
      stateTestTransitionModalOpen: false,

      vaccinationCardPdfModalOpen: false,
      vaccinationCertPdfModalOpen: false,

      patientInfoPopupBookingId: undefined,
      changeEmployeeMailPatientId: undefined,

      cancelTokenSource
    };

    this.questionSetMap = _.keyBy(this.props.questionSets, "id");
    this.interventionBookingHistoryMap = _.keyBy(this.props.interventions, "id");
    this.interventionMap = _.keyBy(this.props.interventions, "id");
    this.resourceMap = _.keyBy(this.props.resources, "id");
  }

  onPatientNameClick = (patientId: number, bookingId: number) => {

    const {cancelTokenSource} = this.state;

    this.setState({
      patientInfoLoading: true
    });

    getPatientForPatientCentral(patientId, cancelTokenSource)
        .then(response => {
          this.setState({
            patientInfo: response,
            patientInfoPopupBookingId: bookingId
          });
        })
        .finally(() => {
          this.setState({
            patientInfoLoading: false
          });
        });
  };

  onEmailIconClick = (patientId: number) => {

    const {cancelTokenSource} = this.state;

    this.setState({
      patientInfoLoading: true
    });

    getPatientForPatientCentral(patientId, cancelTokenSource)
        .then(response => {
          this.setState({
            patientInfo: response
          });
        })
        .finally(() => {
          this.setState({
            patientInfoLoading: false
          });
        });
  }

  clearPatientInfoState = () => {
    this.setState({
      patientInfo: undefined,
      patientInfoPopupBookingId: undefined
    });
  }

  onInterventionNameClick = async (rowData: InterventionTestBookingSearchResult) => {
    const {cancelTokenSource} = this.state;

    let productId = rowData.productId;

    const onFinally = () => {
      this.setState({
        interventionInfoLoading: false
      });
    }

    this.setState({
      testkitSetResultBooking: rowData,
      interventionInfoLoading: true
    });

    if (productId) {
      this.setState({
        interventionPricePatient: undefined,
        interventionPriceInsurance: undefined,
        productId: productId
      });

      try {
        const interventionInvoicePrice = await getInterventionPrice(productId, toIsoDateString(moment()), cancelTokenSource);
        this.setState({
          invoiceProduct: interventionInvoicePrice.invoiceProduct
        });
        const privateTariffInvoices = interventionInvoicePrice.invoices.filter(inv => inv.privateTariff);
        if (privateTariffInvoices) {
          const totalAmountPrivateTariff = privateTariffInvoices.reduce(
              (total, invoice) => total + invoice.amount, 0);

          this.setState({interventionPricePatient: totalAmountPrivateTariff});
        }

        const insuranceInvoices = interventionInvoicePrice.invoices.filter(inv => !inv.privateTariff);
        if (insuranceInvoices) {
          const totalAmountInsurance = insuranceInvoices.reduce(
              (total, invoice) => total + invoice.amount, 0);

          this.setState({interventionPriceInsurance: totalAmountInsurance});
        }
      } finally {
        onFinally();
      }
    } else {
      const patientId = rowData.patientId;
      const intervention = this.interventionMap[rowData.interventionId];
      if (patientId && intervention) {
        try {
          const employeeDefaultParameters =
              await getDefaultTestParametersForEmployee(patientId, intervention.externalCode, cancelTokenSource);

          this.setState({
            employeeDefaultParameters
          });
        } finally {
          onFinally();
        }
      }
      onFinally();
    }
  };

  onInvoiceInterventionClick = async (bookingId: number, treaterId: number) => {

    const {cancelTokenSource} = this.state;

    this.setState({
      interventionInfoLoading: true
    })
    try {
      await invoiceInterventionBooking(bookingId, treaterId, cancelTokenSource);
      this.props.onInvoiceBookingDone(bookingId);
    } catch (e) {
      this.handleError(e.response.data)
    }

    this.setState({
      interventionInfoLoading: false
    })
  }

  onDeleteInterventionInvoiceClick = async (bookingId: number) => {

    const {cancelTokenSource} = this.state;

    try {
      await deleteInterventionBookingInvoice(bookingId, cancelTokenSource);
      this.props.onInvoiceBookingDone(bookingId);
    } catch (e) {
      this.handleError(e.response.data)
    }
  }

  onInterventionNamePopupClose = () => {
    this.setState({
      invoiceProduct: undefined,
      employeeDefaultParameters: undefined,
      interventionPricePatient: undefined,
      interventionPriceInsurance: undefined
    });
  };

  showPoolSingularizationModal = (poolTestId: number) => {
    this.setState(({}: State) => ({
      poolSingularizationModalOpen: true,
      poolSingularizationId: poolTestId
    }));
  };

  hidePoolSingularizationModal = () => {
    this.setState(({}: State) => ({
      poolSingularizationModalOpen: false
    }));
  };

  showAddTestkitCodeModal = (patientId: number) => {
    this.setState(({}: State) => ({
      testkitRegistrationBookingId: patientId,
      addTestkitCodeModalOpen: true
    }));
  };

  hideAddTestkitCodeModal = () => {
    this.setState(({}: State) => ({
      testkitRegistrationBookingId: undefined,
      addTestkitCodeModalOpen: false
    }));
  };

  onAddTestkitCode = () => {
    const bookingId = this.state.testkitRegistrationBookingId;
    if (bookingId) {
      this.props.onRefreshBooking(bookingId)
    }

    this.hideAddTestkitCodeModal();
  }

  showTestCheckInModal = (booking: InterventionBookingSearchResult) => {
    this.setState({
      bookingInTransition: booking,
      statusChangePopupOpen: undefined,
      stateTestTransitionModalOpen: true
    });
  }

  showSetTestkitResultModal = (rowData: InterventionTestBookingSearchResult) => {
    this.setState(() => ({
      testkitSetResultBooking: rowData,
      testkitSetResultModalOpen: true
    }));
  };

  hideSetTestkitResultModal = () => {
    this.setState(() => ({
      testkitSetResultBooking: undefined,
      testkitSetResultModalOpen: false
    }));
  };

  closeSetTestkitResultModalAndUpdateBooking = (bookingId: number) => {
    this.hideSetTestkitResultModal();
    this.props.onUpdateBookingTestResult(bookingId);
  };

  showSetTestPanelResultModal = (rowData: InterventionTestBookingSearchResult) => {
    this.setState(() => ({
      testkitSetResultBooking: rowData,
      testkitSetHpvResultModalOpen: true
    }));
  };

  hideSetHpvTestkitResultModal = () => {
    this.setState(() => ({
      testkitSetResultBooking: undefined,
      testkitSetHpvResultModalOpen: false
    }));
  };

  closeSetHpvTestkitResultModalAndUpdateBooking = (bookingId: number) => {
    this.hideSetHpvTestkitResultModal();
    this.props.onUpdateBookingTestResult(bookingId);
  };

  showSetQuestionsTestResultModal = (rowData: InterventionTestBookingSearchResult) => {
    this.setState(() => ({
      testkitSetResultBooking: rowData,
      testkitSetQuestionsResultModalOpen: true
    }));
  };

  hideSetQuestionsTestResultModal = () => {
    this.setState(() => ({
      testkitSetResultBooking: undefined,
      testkitSetQuestionsResultModalOpen: false
    }));
  };

  closeSetQuestionsTestResultModalAndUpdateBooking = (bookingId: number) => {
    this.hideSetQuestionsTestResultModal();
    this.props.onUpdateBookingTestResult(bookingId);
  };

  onPoolTestClick = (poolTestId: number) => {

    const {cancelTokenSource} = this.state;

    this.setState({
      poolTestkitOverviewLoading: true
    });

    getDetailedPoolTestKits(poolTestId, cancelTokenSource)
        .then(response => {
          this.setState({
            poolTestkitOverviewData: response
          });
        })
        .finally(() => {
          this.setState({
            poolTestkitOverviewLoading: false
          });
        });
  };

  clearPoolTestkitOverviewState = () => {
    this.setState({
      poolTestkitOverviewData: this.initialPoolTestkitOverview
    })
  };

  resendTestResultEmail = (bookingId: number) => {
    const {cancelTokenSource} = this.state;

    resendTestResultEmail(bookingId, cancelTokenSource)
        .then(response => {
          this.setState({
            resendTestResultEmail: response.emailSent
          })
        })
        .catch((e: any) => this.handleError(e.response.data));
  }

  triggerFastPrintPatientDocuments = async (patientId: number) => {
    const {config} = this.props;

    this.setState({
      printLabelPopupOpen: true,
      printLabelPopupStatus: "STARTED"
    })

    const extStatus = await getChromeExtensionStatus(config);

    if (ChromeExtensionStatus.NO_EXTENSION === extStatus) {
      this.setState({
        printLabelPopupStatus: extStatus
      });
    } else if (ChromeExtensionStatus.OUTDATED_EXTENSION === extStatus) {
      this.setState({
        printLabelPopupStatus: extStatus
      });
    } else if (ChromeExtensionStatus.NO_HOST_APPLICATION === extStatus) {
      this.setState({
        printLabelPopupStatus: extStatus
      });
    } else if (ChromeExtensionStatus.OUTDATED_HOST_APP === extStatus) {
      this.setState({
        printLabelPopupStatus: extStatus
      });
    } else if (ChromeExtensionStatus.OK === extStatus) {
      this.setState({
        printLabelPopupStatus: "RETRIEVING_PRINTERS"
      });

      const printersResult: any = await getPrinters();
      const printers = printersResult.payload;
      // @ts-ignore
      const labelPrinter: any = printers.find(printer => {
        const printerName: string = printer.name.toLowerCase();
        return printerName.includes("dymo") && printerName.includes("450");
        // return printerName.includes("microsoft") && printerName.includes("pdf");
      });

      if (labelPrinter) {
        this.setState({
          printLabelPopupStatus: "CREATING_LABELS"
        });
        const documents = await fastPrintPatientDocuments(this.state.cancelTokenSource, patientId);

        this.setState({
          printLabelPopupStatus: "PRINTING_LABELS"
        });

        for (const doc of documents) {
          await printDocument(doc, labelPrinter.name);
        }

        this.setState({
          printLabelPopupStatus: "DONE"
        });
      } else {
        this.setState({
          printLabelPopupStatus: "PRINTER_NOT_FOUND"
        });
      }
    }
  };

  closePrintLabelPopup = (toggle: (() => void) | undefined) => {

    if (toggle) {
      toggle();
    }

    this.setState({
      printLabelPopupOpen: false
    });
  }

  printLabelPopupContent = (toggle: (() => void) | undefined) => {
    const {getMessage} = this.props;
    const {printLabelPopupStatus} = this.state;

    let content = () => {
      switch (printLabelPopupStatus.toUpperCase()) {
        case 'STARTED' :
          return <div>...</div>;

        case 'NO_EXTENSION' :
          return <InfoDiv>
            <div className="info-message">
              {getMessage('nativeTools.status.NO_EXTENSION')}
              <div className="download-link">
                <a href="https://chrome.google.com/webstore/detail/iggeppehjnmjeeicldkpjopdofglljei?authuser=0&hl=en"
                   target="_blank">{getMessage('nativeTools.download.chromeExtension')}</a>
              </div>
            </div>
          </InfoDiv>;

        case 'OUTDATED_EXTENSION' :
          return <InfoDiv>
            <div className="info-message">
              {getMessage('nativeTools.status.OUTDATED_EXTENSION')}
              <div className="download-link">
                <a href="https://praxmedic.ch/native-tools" target="_blank">
                  {getMessage('nativeTools.download.chromeExtension')}
                </a>
              </div>
            </div>
          </InfoDiv>;

        case 'NO_HOST_APPLICATION' :
          return <InfoDiv>
            <div className="info-message">
              {getMessage('nativeTools.status.NO_HOST_APPLICATION')}
              <div className="download-link">
                <a href="https://praxmedic.ch/native-tools" target="_blank">
                  {getMessage('nativeTools.download.hostApplication')}
                </a>
              </div>
            </div>
          </InfoDiv>;

        case 'OUTDATED_HOST_APP' :
          return <InfoDiv>
            <div className="info-message">
              {getMessage('nativeTools.status.OUTDATED_HOST_APP')}
              <div className="download-link">
                <a href="https://praxmedic.ch/native-tools" target="_blank">
                  {getMessage('nativeTools.download.hostApplication')}
                </a>
              </div>
            </div>
          </InfoDiv>;

        case 'PRINTER_NOT_FOUND' :
          return <div>The label printer was not found.</div>;

        case 'RETRIEVING_PRINTERS' :
          return <div>Retrieving available printers...</div>;

        case 'CREATING_LABELS' :
          return <div>Creating labels...</div>;

        case 'PRINTING_LABELS' :
          return <div>Printing labels...</div>;

        case 'DONE' :
          return <div>Labels printed.</div>;
      }
    }

    return (
        <div>
          {content()}
          <div>
            <Button type="button" compact onClick={() => this.closePrintLabelPopup(toggle)}>
              {getMessage("button.close")}
            </Button>
          </div>
        </div>
    )
  }

  onAnamnesisInfoColumnClick = (bookingId: number) => {

    const {cancelTokenSource} = this.state;

    this.setState({
      questionAnswerPairsLoading: true
    });
    getInterventionBookingAnswers(bookingId, cancelTokenSource)
        .then(response => {
          this.setState({
            questionAnswerPairs: response
          });
        })
        .finally(() => {
          this.setState({
            questionAnswerPairsLoading: false
          });
        });
  };

  clearQuestionAnswerPairState = () => {
    this.setState({
      questionAnswerPairs: []
    })
  }

  onStatusColumnClick = (bookingId: number) => {

    const {cancelTokenSource} = this.state;

    this.setState({
      interventionBookingHistoryLoading: true
    });
    getInterventionBookingHistory(bookingId, cancelTokenSource)
        .then(response => {
          this.setState({
            interventionBookingHistory: response
          });
        })
        .finally(() => {
          this.setState({
            interventionBookingHistoryLoading: false
          });
        });
  };

  showCheckInOutPopup = (rowData: InterventionBookingSearchResult | InterventionTestBookingSearchResult) => {
    this.setState({
      bookingInTransition: rowData,
      statusChangePopupOpen: undefined,
      stateVaccinationTransitionModalOpen: true
    })
  }

  closeCheckInOutPopup = () => {
    this.setState({
      stateVaccinationTransitionModalOpen: false,
      bookingInTransition: undefined
    })
  }

  closeCancelSecondDoseModal = () => {
    this.props.setCanceledInterventionBookingData(undefined);
  }

  closeTestCheckInOutPopup = () => {
    this.setState({
      stateTestTransitionModalOpen: false,
      bookingInTransition: undefined
    })
  };

  openVaccinationCertificateErrorModal = (error: ObjectValidationErrorDto) => {
    this.setState({
      generateVaccinationCertificateError: error
    })
  };

  openVaccinationCardPdfModal = (pdfResponses: PdfResponse[]) => {
    this.setState({
      vaccinationCardPdfModalOpen: true,
      vaccinationDocuments: pdfResponses
    })
  };

  openVaccinationCertPdfModal = (pdfResponses: PdfResponse[]) => {
    this.setState({
      vaccinationCertPdfModalOpen: true,
      vaccinationDocuments: pdfResponses
    })
  };

  closeVaccinationCertificateErrorModal = async () => {
    const {bookingInTransition} = this.state;
    const bookingId = bookingInTransition!.bookingId;

    this.setState({
      generateVaccinationCertificateError: undefined
    });

    await this.props.onUpdateBookingStatus(bookingId, InterventionBookingStatus.COMPLETED);
  }

  closeVaccinationCardPdfModal = async () => {
    const {bookingInTransition} = this.state;
    const bookingId = bookingInTransition!.bookingId;

    this.setState({
      vaccinationCardPdfModalOpen: false,
      vaccinationDocuments: undefined
    });

    await this.props.onUpdateBookingStatus(bookingId, InterventionBookingStatus.AWAITING_COMPLETION);
  }

  closeVaccinationCertificatePdfModal = async () => {
    const {bookingInTransition} = this.state;
    const bookingId = bookingInTransition!.bookingId;

    this.setState({
      vaccinationCertPdfModalOpen: false,
      vaccinationDocuments: undefined
    });

    await this.props.onUpdateBookingStatus(bookingId, InterventionBookingStatus.COMPLETED);
  };

  openEditEmailModal = (patientId: number) => {
    this.setState({
      changeEmployeeMailPatientId: patientId,
      patientInfoPopupBookingId: undefined,
      patientInfo: undefined
    });
  }

  setErrorMessage = (errorMessage?: string) => {

    const {errorMessages} = this.state;

    if (errorMessage) {

      const errMsgs = [...errorMessages];
      errMsgs.push(errorMessage);

      this.setState({
        errorMessages: errMsgs
      });
    } else {

      this.setState({
        errorMessages: []
      });
    }
  };

  handleError(error: any) {
    const {getMessage} = this.props;
    const errorCode = error.errorCode;
    const knownErrors: Array<string> = [
      "UNKNOWN_TEST_ATTACHMENT_ID",
      "EMPTY_BYTE_ARRAY_TEST_ATTACHMENT_BLOB",
      "BLOB_CONTAINER_NOT_INITIALIZED",
      "AZURE_IS_DOWN",
      "INTERVENTION_CAN_NOT_BE_INVOICED",
      "intervention.invoice.ERROR_INVALID_MANDATE_BANK",
      errorUtils.unknownVaccinationRecord,
      errorUtils.unknownMandate,
      errorUtils.deleteInvoiceNotAllowed,
      errorUtils.canNotChangeOnHoldStatus,
      errorUtils.notCompletedBookingResendEmail
    ];

    const violations: Array<any> = error.violations;

    if (violations && violations.length > 0) {
      violations.forEach(violation => {
        if (knownErrors.includes(violation.errorCode)) {
          this.setErrorMessage(getMessage(`error.${violation.errorCode}`));
        }
      });
    }

    if (knownErrors.includes(error.message)) {
      this.setErrorMessage(getMessage(`error.${error.message}`));
    }

    if (!this.state.errorMessages.length) {
      if (knownErrors.includes(errorCode)) {
        this.setErrorMessage(getMessage(`error.${errorCode}`));
      } else {
        this.setErrorMessage(getMessage('error.general'));
      }
    }
  }

  getGetResultImagePdfUrl = (resultImage: EmployeeTestResultImagePdfDto) => {
    const content = getPdfImageUrl(
        resultImage.pdfId, resultImage.pdfName, resultImage.testResultFileType);
    return content;
  }

  render(): React.ReactNode {
    const {bookings, bookingsLoading, getMessage} = this.props;
    const {
      resultImage,
      errorMessages,
      changeEmployeeMailPatientId,
      resultImageLoading,
      vaccinationDocuments,
      vaccinationCertPdfModalOpen,
      vaccinationCardPdfModalOpen,
      generateVaccinationCertificateError,
      resendTestResultEmail
    } = this.state;

    if (bookingsLoading) {
      return (
          <Loader active={true} size="small" inline="centered"/>
      );
    }

    return (
        <>
          {
              errorMessages.length > 0 &&
              <StyledErrorMessage onDismiss={() => this.setErrorMessage()}>
                {errorMessages.map(err => <div key={err}>{err}</div>)}
              </StyledErrorMessage>
          }
          {
            resendTestResultEmail !== undefined
                ? resendTestResultEmail
                    ? <Message
                        success
                        onDismiss={() => this.setState({resendTestResultEmail: undefined})}
                        style={{marginLeft: "7px", marginRight: "7px"}}>
                      {getMessage("patientCentral.resendTestResultEmail.success")}
                    </Message>
                    : <StyledErrorMessage onDismiss={() => this.setState({resendTestResultEmail: undefined})}>
                      {getMessage("patientCentral.resendTestResultEmail.error")}
                    </StyledErrorMessage>
                : <></>
          }
          <TableDiv>
            {
              (bookings.length > 0)
                  ? this.renderTable(bookings)
                  : (
                      <NoDataDiv> {getMessage("patientCentral.overview.table.noMatches")}</NoDataDiv>
                  )
            }
          </TableDiv>

          {this.renderVaccinationTransitionDetailsModal()}
          {this.renderTestTransitionDetailsModal()}
          {this.renderPoolTestSingularizationModal()}

          {this.props.canceledInterventionBookingData &&
              this.renderCancelSecondDoseModal()
          }
          {this.renderAddTestkitCodeModal()}
          {this.renderSetTestkitResultModal()}
          {this.renderSetHpvTestkitResultModal()}
          {this.renderSetQuestionTestResultModal()}

          {
              this.state.changeEmployeeMailPatientId &&
              <ChangeEmployeeEmailModal
                  open={true}
                  patientId={changeEmployeeMailPatientId}
                  onClose={() => {
                    this.setState({
                      changeEmployeeMailPatientId: undefined
                    });
                  }}
              />
          }

          {resultImageLoading && <LoaderComponent message={getMessage("loading")}/>}

          {
              resultImage &&
              <FullScreenLightBox
                  mainSrc={`data:${resultImage.testResultFileType};base64, ${resultImage.testResultImage}`}
                  onCloseRequest={() => this.setState({resultImage: undefined})}
                  toolbarButtons={[
                    <StyledButton
                        href={this.getGetResultImagePdfUrl(resultImage)}
                        download={resultImage.pdfName}
                        icon
                        inverted
                        className="styled-button"
                    >
                      <Icon name="download" size="large"/>
                    </StyledButton>
                  ]}
              />
          }
          {
              (vaccinationCertPdfModalOpen || vaccinationCardPdfModalOpen) &&
              <PdfModal
                  modalOpen={vaccinationCertPdfModalOpen || vaccinationCardPdfModalOpen}
                  onCloseModal={vaccinationCertPdfModalOpen
                      ? this.closeVaccinationCertificatePdfModal
                      : this.closeVaccinationCardPdfModal}
                  pdfResponses={vaccinationDocuments}
                  getPdfUrl={getPdfUrl}
              />
          }
          {generateVaccinationCertificateError && this.renderGenerateVaccinationCertificateErrorModal()}
        </>
    );
  }

  renderGenerateVaccinationCertificateErrorModal = () => {
    const {getMessage} = this.props;
    const {generateVaccinationCertificateError} = this.state;

    let warningMessage = "";

    let specificError = undefined;
    if (generateVaccinationCertificateError) {
      specificError = generateVaccinationCertificateError.details;
    }

    if (specificError) {
      warningMessage = specificError;
    } else {
      warningMessage = getMessage("error.general");
    }

    return (
        <Modal
            open={true}
            onClose={this.closeVaccinationCertificateErrorModal}
            closeOnDimmerClick={false}
        >
          <Modal.Header>
            {getMessage("patientCentral.checkOut.error.title")}
          </Modal.Header>
          <Modal.Content>
            <StyledErrorContainer>
              <Icon name="warning sign"/> {warningMessage}
            </StyledErrorContainer>
          </Modal.Content>
          <Modal.Actions>
            <Button compact
                    type="button"
                    onClick={this.closeVaccinationCertificateErrorModal}
            >
              {getMessage("button.close")}
            </Button>
          </Modal.Actions>
        </Modal>
    )
  };

  renderTable = (bookings: InterventionBookings): JSX.Element => {

    const {batchTestVerificationEnabled, getMessage} = this.props;

    const searchBy = this.props.bookingSearchRequest.searchBy;
    const isEntrySearch = searchBy === InterventionBookingSearchBy.ENTRY_DATE;
    const isAppointmentSearch = searchBy === InterventionBookingSearchBy.APPOINTMENT_DATE;
    const isTestSearch = searchBy === InterventionBookingSearchBy.COVID_TEST;
    const isVaccinationSearch = searchBy === InterventionBookingSearchBy.VACCINATION;

    const testDateSearchBy = this.props.bookingSearchRequest.testDateSearchBy;
    const vaccinationDateSearchBy = this.props.bookingSearchRequest.vaccinationDateSearchBy;
    let dateMessageKey = TestDateSearchBy.BOOKING_DATE;

    if ((testDateSearchBy && isTestSearch && testDateSearchBy === TestDateSearchBy.APPOINTMENT_DATE)
        || (isVaccinationSearch && vaccinationDateSearchBy && vaccinationDateSearchBy === TestDateSearchBy.APPOINTMENT_DATE)) {
      dateMessageKey = TestDateSearchBy.APPOINTMENT_DATE;
    }

    if ((testDateSearchBy && isTestSearch && testDateSearchBy === TestDateSearchBy.CHECK_IN_DATE)
        || (isVaccinationSearch && vaccinationDateSearchBy && vaccinationDateSearchBy === TestDateSearchBy.CHECK_IN_DATE)) {
      dateMessageKey = TestDateSearchBy.CHECK_IN_DATE;
    }

    if (testDateSearchBy && isTestSearch && testDateSearchBy === TestDateSearchBy.LAB_RECEIVED_DATE) {
      dateMessageKey = TestDateSearchBy.LAB_RECEIVED_DATE;
    }

    if (testDateSearchBy && isTestSearch && testDateSearchBy === TestDateSearchBy.RESULT_DATE) {
      dateMessageKey = TestDateSearchBy.RESULT_DATE;
    }

    if (testDateSearchBy && isTestSearch && testDateSearchBy === TestDateSearchBy.RESULT_VERIFIED_DATE) {
      dateMessageKey = TestDateSearchBy.RESULT_VERIFIED_DATE;
    }

    const tableColumns: ExtendedColumnProps[] = [];

    if (isTestSearch) {
      tableColumns.push({
        width: 90,
        label: batchTestVerificationEnabled ? this.selectHeaderColumn(true) : "",
        dataKey: "urgency",
        cellRenderer: this.urgencyCellRenderer
      });
    }
    if (isVaccinationSearch) {
      tableColumns.push({
        width: 50,
        label: this.selectHeaderColumn(false),
        dataKey: "index",
        cellRenderer: this.bookingSelectCellRenderer
      });
    }
    tableColumns.push(
        {
          width: 80,
          flexGrow: 0,
          flexShrink: 0,
          label: getMessage("patientCentral.overview.tableHeader.patientId"),
          dataKey: "patientId",
          cellRenderer: this.patientIdCellRenderer
        },
        {
          width: 100,
          flexGrow: 1,
          flexShrink: 0,
          label: `${getMessage("patientCentral.overview.tableHeader.patientFirstName")} ${getMessage("patientCentral.overview.tableHeader.patientLastName")}`,
          dataKey: "patientId",
          cellRenderer: this.patientNameCellRenderer
        },
        {
          width: 120,
          flexGrow: 0,
          flexShrink: 0,
          label: getMessage("patientCentral.overview.tableHeader.patientBirthDate"),
          dataKey: "patientFirstName",
          cellRenderer: this.patientBirthDateCellRenderer
        },
        {
          width: 100,
          flexGrow: 0,
          flexShrink: 0,
          label: getMessage("patientCentral.overview.tableHeader.inputChannel"),
          dataKey: "inputChannel",
          cellRenderer: this.inputChannelCellRenderer
        },
        {
          width: 150,
          flexGrow: 0,
          flexShrink: 0,
          label: getMessage(`enum.testDateSearchBy.${dateMessageKey}`),
          dataKey: "bookingDate",
          cellRenderer: this.entryDateCellRenderer
        });


    if (isEntrySearch || isAppointmentSearch || isVaccinationSearch) {
      tableColumns.push({
        width: 100,
        flexGrow: 2,
        flexShrink: 0,
        label: getMessage("patientCentral.overview.tableHeader.anamnesis"),
        dataKey: "questionSetId",
        cellRenderer: this.questionSetCellRenderer
      });
    }

    tableColumns.push({
      width: 115,
      flexGrow: isTestSearch ? 2 : 1,
      flexShrink: 0,
      label: getMessage(`patientCentral.overview.tableHeader.intervention`),
      dataKey: "interventionId",
      cellRenderer: this.interventionCellRenderer
    });

    if (isEntrySearch || isAppointmentSearch || isVaccinationSearch) {
      tableColumns.push(
          {
            width: 100,
            flexGrow: 0,
            flexShrink: 0,
            label: getMessage("patientCentral.overview.tableHeader.location"),
            dataKey: "bookigData.locationId",
            cellRenderer: this.appointmentLocationCellRenderer
          },
          {
            width: 150,
            flexGrow: 0,
            flexShrink: 0,
            label: getMessage("patientCentral.overview.tableHeader.appointmentDateTime"),
            dataKey: "type",
            cellRenderer: this.appointmentDateTimeCellRenderer
          }/*,
          {
            width: 100,
            flexGrow: 0,
            flexShrink: 0,
            label: getMessage("patientCentral.overview.tableHeader.authorityNotificationStatus"),
            dataKey: "authorityNotificationStatus",
            cellRenderer: this.authorityNotificationStatusCellRenderer
          }*/
      );
    }

    if (isTestSearch) {
      tableColumns.push(
          {
            width: 168,
            flexGrow: 1,
            flexShrink: 0,
            label: getMessage("patientCentral.overview.tableHeader.testKitCode"),
            dataKey: "testKitCode",
            cellRenderer: this.testKitCodeCellRenderer
          },
          {
            width: 68,
            flexGrow: 0,
            flexShrink: 0,
            label: getMessage("patientCentral.overview.tableHeader.testResult"),
            dataKey: "testResult",
            cellRenderer: this.testResultCellRenderer
          }
      );
    }

    tableColumns.push(
        {
          width: 135,
          flexGrow: 0,
          flexShrink: 0,
          label: getMessage("patientCentral.overview.tableHeader.rowActions"),
          dataKey: "firstName",
          cellRenderer: this.rowActionsCellRenderer
        },
        {
          width: 115,
          flexGrow: 0,
          flexShrink: 0,
          label: getMessage("patientCentral.overview.tableHeader.status"),
          dataKey: "status",
          cellRenderer: this.interventionStatusCellRenderer
        }
    );

    return (
        <StyledTable
            rowGetter={this.bookingsRowGetter(bookings)}
            rowRenderer={this.bookingsRowRenderer(bookings)}
            rowCount={bookings.length}
            rowHeight={38}
            columns={tableColumns}
        />
    )
  };

  bookingsRowGetter = (bookings: InterventionBookings) => ({index}: any) => {

    if (bookings[index]) {
      Object.assign(bookings[index], {index: index + 1});

      return bookings[index];
    }

    return {
      index: index + 1
    }
  };

  bookingsRowRenderer = (bookings: InterventionBookings) =>
      ({className, columns, index, key, style}: any) => {

        const a11yProps = {"aria-rowindex": index + 1};

        let styles = {...style};

        return (
            <div
                {...a11yProps}
                className={className}
                key={key}
                role="row"
                style={styles}
            >
              {columns}
            </div>
        );
      };

  selectHeaderColumn = (isTestSearch: boolean) => {

    const {
      bookings,
      selectedInterventionBookings,
      selectVaccinationStatus,
      selectedTestInterventionBookings,
      selectVerifyTestResults
    } = this.props;

    const countSelectableBookings = (bookings as any)
        .filter((b: any) => isTestSearch ? isTestInterventionSelectable(b, selectVerifyTestResults) : isBookingSelectable(b, selectVaccinationStatus)).length;

    const countSelectedBookings = isTestSearch ? selectedTestInterventionBookings.size : selectedInterventionBookings.size;
    const indeterminate = countSelectedBookings > 0
        && countSelectedBookings < countSelectableBookings;
    const noSelectedTestRegistrations = countSelectedBookings === 0
        && countSelectableBookings > 0;
    const allTestRegistrationsSelected = countSelectableBookings > 0
        && countSelectedBookings === countSelectableBookings;

    return (
        <CheckboxSc
            checked={countSelectedBookings > 0}
            indeterminate={indeterminate}
            onChange={
              () => {
                if (noSelectedTestRegistrations || indeterminate) {
                  const bookingIds = (bookings as any)
                      .filter((b: any) => isTestSearch
                          ? isTestInterventionSelectable(b, selectVerifyTestResults)
                          : isBookingSelectable(b, selectVaccinationStatus)).map((b: any) => b.bookingId);
                  this.props.onUpdateBookings(new Set(bookingIds), isTestSearch);
                }

                if (allTestRegistrationsSelected) {
                  this.props.onUpdateBookings(new Set(), isTestSearch);
                }

              }
            }
            disabled={countSelectableBookings === 0}
        />
    );
  };

  isBookingSelected = (booking: InterventionBookingSearchResult | InterventionTestBookingSearchResult,
                       isTestSearch: boolean) => {

    const {selectedInterventionBookings, selectedTestInterventionBookings} = this.props;
    return isTestSearch
        ? selectedTestInterventionBookings.has(booking.bookingId)
        : selectedInterventionBookings.has(booking.bookingId);

  };

  selectBooking = (index: number, isTestSearch: boolean) => {

    const {bookings, selectedInterventionBookings, selectedTestInterventionBookings} = this.props;

    if (bookings[index]) {

      let selectedVaccinationIntervention = new Set(selectedInterventionBookings);
      let selectedTestIntervention = new Set(selectedInterventionBookings);

      const bookingId = bookings[index].bookingId;

      if (isTestSearch) {
        if (selectedTestInterventionBookings.has(bookingId)) {
          this.props.onUpdateBookingSelection(bookingId, false, true);
        } else {
          this.props.onUpdateBookingSelection(bookingId, true, true);
          selectedTestIntervention.add(bookingId);
        }
      } else {
        if (selectedInterventionBookings.has(bookingId)) {
          this.props.onUpdateBookingSelection(bookingId, false, false);
        } else {
          this.props.onUpdateBookingSelection(bookingId, true, false);
          selectedVaccinationIntervention.add(bookingId);
        }
      }
    }
  }

  urgencyCellRenderer = (data: any) => {
    const {
      batchTestVerificationEnabled,
      selectVerifyTestResults,
      getMessage,
      getMessageWithNamedParams
    } = this.props;

    const {cellData, rowData} = data;
    const index = rowData.index - 1;

    const testKit: InterventionTestBookingSearchResult = rowData;
    let selectTestIntervention = <></>

    if (batchTestVerificationEnabled
        && isTestInterventionSelectable(testKit, selectVerifyTestResults)) {

      selectTestIntervention = (
          <CheckboxSc
              checked={this.isBookingSelected(rowData, true)}
              disabled={false}
              onChange={() => this.selectBooking(index, true)}
          />
      );
    }

    const expectedResultTime = rowData.expectedResultTime;
    const expectedResultDate = rowData.expectedResultDate;
    let expectedResultDateTime = <></>;
    if (expectedResultDate && expectedResultTime) {

      const expectedResDate = moment(expectedResultDate)
      let numberOfDays = undefined;
      if (moment(expectedResultDate).isAfter()) {
        numberOfDays = expectedResDate.diff(moment(), 'days') + 1;
      }

      const expectedTime = `${expectedResultTime}`;
      const expectedDateTime = `${isoToDisplayDate(expectedResultDate)} - ${expectedTime}`;

      const expectedInstant = moment(`${expectedResultDate} ${expectedResultTime}`);
      const minutesToResult = expectedInstant.diff(moment(), 'minutes');
      let textClass = 'normal';
      if (minutesToResult > 0 && minutesToResult < 30) {
        textClass = 'warn';
      } else if (minutesToResult < 0) {
        textClass = 'overdue';
      }

      expectedResultDateTime = (
          <div className={`expected-date ${textClass}`} title={expectedDateTime}>
            {expectedResultTime}
            {numberOfDays && getMessageWithNamedParams(
                'patientCentral.overview.row.days',
                {numberOfDays: numberOfDays}
            )
            }
          </div>
      );
    }

    return cellData && cellData === Urgency.HIGH
        ? <>
          {selectTestIntervention}
          {expectedResultDateTime}
          <Icon name="exclamation triangle"
                color="red"
                style={{marginLeft: ".5rem"}}
                title={`${getMessage("patientCentral.checkIn.urgency")}: ${getMessage("enum.urgency.HIGH")}`}
          />
        </>
        : <>{selectTestIntervention}{expectedResultDateTime}</>;
  };

  bookingSelectCellRenderer = (data: any) => {

    const {selectVaccinationStatus} = this.props;

    const {cellData, rowData} = data;
    const index = cellData - 1;

    const testKit: InterventionBookingSearchResult = rowData;

    if (isBookingSelectable(testKit, selectVaccinationStatus)) {
      return (
          <CheckboxSc
              checked={this.isBookingSelected(rowData, false)}
              disabled={false}
              onChange={() => this.selectBooking(index, false)}
          />
      )
    }
    return <></>;
  };

  patientIdCellRenderer = (data: any) => {

    const {getMessage, verifyTestResultsResponse} = this.props;
    const {poolTestkitOverviewData, poolTestkitOverviewLoading} = this.state;
    const {rowData} = data;
    const verifyTestResultsError = verifyTestResultsResponse ? verifyTestResultsResponse.errorItems : [];
    const verifyEmailStatus = rowData.verifyEmailStatus;
    const {patientInfoLoading, patientInfo} = this.state;

    const patientEmailPopup = (popupTrigger: any) => (
        <Popup
            trigger={popupTrigger}
            popperDependencies={[!!patientInfoLoading]}
            popperModifiers={{
              preventOverflow: {
                boundary: document.getElementById("patientCentralMainContent")
              }
            }}
            content={
              patientInfoLoading
                  ? loader
                  : <PatientInfoPopUpView
                      patientInfo={patientInfo}
                      patientId={rowData.patientId}
                      verifyEmailStatus={verifyEmailStatus}
                  />
            }
            flowing
            on="click"
            onClose={this.clearPatientInfoState}
            size="large"
            position="right center"
        />
    );

    let errorIcon = <></>;
    let verifyEmailStatusIcon = <></>;
    let bookingError;
    if (verifyTestResultsError != undefined && verifyTestResultsError.length > 0) {
      bookingError = verifyTestResultsError.find(e => e.interventionBookingId === rowData.bookingId);
    }
    if (bookingError !== undefined) {
      errorIcon = <Icon name="exclamation triangle"
                        color="red"
                        style={{marginLeft: ".5rem"}}
                        size="small"
                        title={getMessage(`error.${bookingError.errorCode}`)}
      />
    }

    if (VerifyEmailStatus.ACCEPTED !== verifyEmailStatus) {

      const icon = <Icon name="mail outline"
                         color={VerifyEmailStatus.PENDING === verifyEmailStatus ? "yellow" : "red"}
                         style={{marginLeft: ".5rem"}}
                         size="small"
                         onClick={() => this.onEmailIconClick(rowData.patientId)}
                         title={getMessage(
                             `patientCentral.overview.row.verifyEmailStatus.${verifyEmailStatus}`)}
      />
      verifyEmailStatusIcon = patientEmailPopup(icon)
    }

    const poolMember: boolean = !_.isNil(rowData.poolTestId) && rowData.poolTestId > 0;

    if (rowData.patientId && !poolMember && !rowData.testSingularized) {
      return (
          <div>
            {`${rowData.patientId}`}
            <>{errorIcon}{verifyEmailStatusIcon}</>
          </div>
      );
    } else if (rowData.patientId && rowData.testSingularized) {
      return (
          <div>
            {`${rowData.patientId}`}
            <span className="text-id-icon">S</span>
            <>{errorIcon}{verifyEmailStatusIcon}</>
          </div>
      );
    }

    let trigger = (<Icon name="boxes" title={getMessage("patientCentral.overview.row.pooltestKit")}/>);

    if (rowData.patientId) {
      trigger = (<div>
        {`${rowData.patientId}`}
        <Icon className="id-icon"
              name="boxes"
              color="grey"
              size="small"
              title={getMessage("patientCentral.overview.row.pooltestKitMember")}/>
        {errorIcon}{verifyEmailStatusIcon}
      </div>);
    }

    const loader = (
        <Loader active inline="centered" size="small">{getMessage("loading")}</Loader>
    );

    const poolTestId = poolMember ? rowData.poolTestId : rowData.testId;

    return (
        <div title={"Pool tests"} onClick={() => this.onPoolTestClick(poolTestId)}>
          <Popup
              trigger={trigger}
              popperDependencies={[poolTestkitOverviewLoading]}
              popperModifiers={{
                preventOverflow: {
                  boundary: document.getElementById("patientCentralMainContent")
                }
              }}
              content={
                poolTestkitOverviewLoading
                    ? loader
                    : <PoolTestkitOverview
                        poolTestId={poolTestId}
                        testId={rowData.testId}
                        poolMember={poolMember}
                        poolTestkitOverviewData={poolTestkitOverviewData}
                    />

                // : this.renderPoolTestKitOverview(poolTestId, rowData.testId, poolMember)
              }
              flowing
              on="click"
              onClose={this.clearPoolTestkitOverviewState}
              size="large"
              position="right center"
          />
        </div>
    )
  }

  patientNameCellRenderer = (data: any) => {

    const {getMessage, anonymousMode} = this.props;
    const {patientInfoLoading, patientInfo, patientInfoPopupBookingId} = this.state;
    const {rowData} = data;

    const loader = (
        <Loader active inline="centered" size="small">{getMessage("loading")}</Loader>
    );

    const patientPopup = (popupTrigger: any) => (
        <Popup
            trigger={popupTrigger}
            open={rowData.bookingId === patientInfoPopupBookingId}
            popperDependencies={[patientInfoLoading]}
            popperModifiers={{
              preventOverflow: {
                boundary: document.getElementById("patientCentralMainContent")
              }
            }}
            content={
              patientInfoLoading
                  ? loader
                  : <PatientInfoView
                      showButtons={true}
                      patientInfo={patientInfo}
                      onEditEmailButtonClick={this.openEditEmailModal}
                  />
            }
            flowing
            on="click"
            onClose={this.clearPatientInfoState}
            size="large"
            position="right center"
        />
    );

    if (anonymousMode) {

      const anonymousField = <div className="deg45 anonymous-stripes"/>;

      if (rowData.patientId) {
        return <div className="deg45 anonymous-stripes"
                    onClick={() => this.onPatientNameClick(rowData.patientId, rowData.bookingId)}>
          {patientPopup(rowData.patientId ? anonymousField : "")}
        </div>;
      } else if (!rowData.patientId) {
        return anonymousField
      }

    }

    let trigger = rowData.patientId
        ? (<span>{`${rowData.patientFirstName} ${rowData.patientLastName}`}</span>)
        : `${rowData.poolCompanyDescription}`;

    if (rowData.companyDescription) {
      trigger = <span title={`${rowData.companyDescription}`}>
        {`${rowData.patientFirstName} ${rowData.patientLastName}`}
      </span>;
    }

    if (rowData.patientId) {
      return (
          <div title={getMessage("patient")}
               onClick={() => this.onPatientNameClick(rowData.patientId, rowData.bookingId)}>
            {patientPopup(trigger)}
          </div>
      );
    }

    return trigger;
  }

  patientBirthDateCellRenderer = (data: any) => {

    const {getMessage} = this.props;
    const {rowData} = data;

    const birthDate = rowData.patientBirthDate
        ? `${isoToDisplayDate(rowData.patientBirthDate)} (${rowData.patientAge})`
        : "";

    return (
        <div>
          <div className="date birth-date" title={birthDate}>{birthDate}</div>
        </div>
    )
  };

  inputChannelCellRenderer = (data: any) => {

    const {getMessage, currentUser, allMandates} = this.props;
    const {rowData} = data;

    const inputChannel = rowData.inputChannel;
    const inputChannelDisplay = getMessage(`enum.interventionBookingInputChannel.${inputChannel}`);
    const mandateId = rowData.mandateId;
    const currentMandateId = currentUser!.userConfig.mandateId;

    const mandate = allMandates ? allMandates.find(mandate => mandate.id == mandateId) : undefined;
    const mandateName = mandate ? mandate.name : "";

    const mandateColor = mandate &&
    mandate.id === currentMandateId
        ? '#FFFFFF'
        : mandate && mandate.color;

    return (
        <div>
          <div className="date birth-date" title={inputChannelDisplay}>
            <div className="icon-div">
              <Icon
                  name="circle"
                  style={{color: `${mandateColor}`}}
                  size="tiny"
                  title={mandateName}
              />
            </div>
            <div className="text-div">
              {inputChannelDisplay}
            </div>
          </div>
        </div>
    )
  };

  entryDateCellRenderer = (data: any) => {

    const {bookingSearchRequest} = this.props;
    const {rowData} = data;

    const isTestSearch = bookingSearchRequest.searchBy === InterventionBookingSearchBy.COVID_TEST;
    const isVaccinationSearch = bookingSearchRequest.searchBy === InterventionBookingSearchBy.VACCINATION;

    const testDateSearchBy = bookingSearchRequest.testDateSearchBy;
    const vaccinationDateSearchBy = bookingSearchRequest.vaccinationDateSearchBy;

    if ((isTestSearch && testDateSearchBy && testDateSearchBy === TestDateSearchBy.APPOINTMENT_DATE)
        || (isVaccinationSearch && vaccinationDateSearchBy && vaccinationDateSearchBy === TestDateSearchBy.APPOINTMENT_DATE)) {
      const appointmentDate = isoToDisplayDate(rowData.appointmentDate);
      const appointmentTime = rowData.appointmentTime;
      const appointmentDateTimeTitle = `${appointmentDate}${appointmentTime ? ` - ${appointmentTime}` : ""}`;

      return (
          <div>
            <div className="date birth-date" title={appointmentDateTimeTitle}>{appointmentDate} {appointmentTime}</div>
          </div>
      )
    }

    if (rowData.checkInTimestamp
        && ((isTestSearch && testDateSearchBy && testDateSearchBy === TestDateSearchBy.CHECK_IN_DATE)
            || (isVaccinationSearch && vaccinationDateSearchBy && vaccinationDateSearchBy === TestDateSearchBy.CHECK_IN_DATE))) {
      const checkInDateTimeTitle = moment(rowData.checkInTimestamp).format('DD.MM.YYYY - HH:mm');
      const checkInDateTime = moment(rowData.checkInTimestamp).format('DD.MM.YYYY HH:mm');

      return (
          <div>
            <div className="date birth-date" title={checkInDateTimeTitle}>{checkInDateTime}</div>
          </div>
      )
    }

    if (rowData.labReceivedTimestamp
        && isTestSearch && testDateSearchBy && testDateSearchBy === TestDateSearchBy.LAB_RECEIVED_DATE) {
      const labReceivedDateTimeTitle = moment(rowData.labReceivedTimestamp).format('DD.MM.YYYY - HH:mm');
      const labReceivedDateTime = moment(rowData.labReceivedTimestamp).format('DD.MM.YYYY HH:mm');

      return (
          <div>
            <div className="date birth-date" title={labReceivedDateTimeTitle}>{labReceivedDateTime}</div>
          </div>
      )
    }

    if (rowData.testResultTimestamp
        && isTestSearch && testDateSearchBy && testDateSearchBy === TestDateSearchBy.RESULT_DATE) {
      const resultDateTimeTitle = moment(rowData.testResultTimestamp).format('DD.MM.YYYY - HH:mm');
      const resultDateTime = moment(rowData.testResultTimestamp).format('DD.MM.YYYY HH:mm');

      return (
          <div>
            <div className="date birth-date" title={resultDateTimeTitle}>{resultDateTime}</div>
          </div>
      )
    }

    if (rowData.resultVerifiedTimestamp
        && isTestSearch && testDateSearchBy && testDateSearchBy === TestDateSearchBy.RESULT_VERIFIED_DATE) {
      const resultVerifiedDateTimeTitle = moment(rowData.resultVerifiedTimestamp).format('DD.MM.YYYY - HH:mm');
      const resultVerifiedDateTime = moment(rowData.resultVerifiedTimestamp).format('DD.MM.YYYY HH:mm');

      return (
          <div>
            <div className="date birth-date" title={resultVerifiedDateTimeTitle}>{resultVerifiedDateTime}</div>
          </div>
      )
    }

    const bookingDate = isoToDisplayDate(rowData.bookingDate);
    const bookingTime = rowData.bookingTime;
    const entryDateTimeTitle = `${bookingDate}${bookingTime ? ` - ${bookingTime}` : ""}`;

    return (
        <div>
          <div className="date birth-date" title={entryDateTimeTitle}>{bookingDate} {bookingTime}</div>
        </div>
    )
  };

  interventionCellRenderer = (data: any) => {

    const {getMessage, productMap, currentUser} = this.props;
    const {
      interventionInfoLoading,
      testkitSetResultBooking,
      invoiceProduct,
      employeeDefaultParameters,
      interventionPricePatient,
      interventionPriceInsurance
    } = this.state;
    const {rowData} = data;

    let productId = rowData.productId;

    const intervention = this.interventionMap[rowData.interventionId];
    const isInterventionInvoiced =
        rowData.status === InterventionBookingStatus.COMPLETED && productId !== null
            ? rowData.invoiced
            : undefined;

    let product = productId ? productMap[productId] : undefined;
    const isFreeProduct = product ? product.freeProduct : true;

    const interventionColor = intervention && intervention.color;

    let invoiceIcon = <></>;
    if (isInterventionInvoiced !== undefined && !isInterventionInvoiced && !isFreeProduct) {
      invoiceIcon = <Icon
          name="money bill alternate outline"
          color="red"
          title={getMessage("patientCentral.tableData.intervention.notInvoiced.tooltip")}
          style={{marginLeft: "5px"}}
      />
    }

    let remarkIcon = <></>;
    const bookingRemarks = rowData.bookingRemarks;
    if (bookingRemarks) {
      remarkIcon = <Icon
          name="comment alternate"
          title={bookingRemarks}
          style={{marginLeft: "5px"}}
      />
    }

    let interventionString = intervention
        ? `${intervention.description}`
        : "";

    let productText = "";
    let productTextLong = "";
    if (product) {
      const defaultDesc = !_.isEmpty(product.description) ? product.description : undefined;

      const texts: { [key: string]: string | undefined } = {
        "de": defaultDesc,
        "en": !_.isEmpty(product.descriptionEn) ? product.descriptionEn : defaultDesc,
        "fr": !_.isEmpty(product.descriptionFr) ? product.descriptionFr : defaultDesc,
        "it": !_.isEmpty(product.descriptionIt) ? product.descriptionIt : defaultDesc
      };

      const lang = currentUser ? currentUser.userConfig.language : "de";
      const desc = texts[lang] ? ` - ${texts[lang]}` : "";

      productText = `${product.id}`;
      productTextLong = `${product.id} ${desc}`;
    }

    const loader = (
        <Loader active inline="centered" size="small">{getMessage("loading")}</Loader>
    );

    const interventionPopup = (popupTrigger: any) => (
        <Popup
            trigger={popupTrigger}
            popperDependencies={[!!interventionInfoLoading, testkitSetResultBooking]}
            popperModifiers={{
              preventOverflow: {
                boundary: document.getElementById("patientCentralMainContent")
              }
            }}
            content={
              interventionInfoLoading
                  ? loader
                  : <InterventionInfoView
                      interventionName={interventionString}
                      interventionInfo={testkitSetResultBooking}
                      invoiceProduct={invoiceProduct}
                      employeeDefaultParameters={employeeDefaultParameters}
                      interventionPricePatient={interventionPricePatient}
                      interventionPriceInsurance={interventionPriceInsurance}
                  />
            }
            flowing
            on="click"
            size="large"
            position="right center"
            onClose={this.onInterventionNamePopupClose}
        />
    );

    let trigger = (
        <div title={interventionString}>
          <div>
            {interventionColor &&
                <div className="intervention-icon-div">
                  <Icon
                      name="circle"
                      style={{color: `${interventionColor}`}}
                      size="small"
                      title={interventionString}
                  />
                </div>
            }
            <span title={interventionString + (_.isEmpty(productTextLong) ? "" : ` (${productTextLong})`)}>
              {interventionString}{_.isEmpty(productText) ? "" : ` (${productText})`}
            </span>
            {invoiceIcon}
            {remarkIcon}
          </div>
        </div>
    )

    if (rowData.interventionId) {
      return (
          <div onClick={() => this.onInterventionNameClick(rowData)}>
            {interventionPopup(trigger)}
          </div>
      )
    }

    return trigger;
  };

  questionSetCellRenderer = (data: any) => {

    const {rowData} = data;
    const questionSetId = rowData.questionSetId;
    if (!questionSetId) {
      return "";
    }

    const {getMessage} = this.props;
    const {questionAnswerPairs, questionAnswerPairsLoading} = this.state;

    const questionSet = this.questionSetMap[questionSetId];
    let questionSetString = "";
    if (questionSet) {
      const nameMap: { [lang: string]: string } = {
        "de": questionSet.name,
        "en": questionSet.nameEn || questionSet.name,
        "fr": questionSet.nameFr || questionSet.name,
        "it": questionSet.nameIt || questionSet.name
      };
      questionSetString = nameMap[this.props.language];
    }

    const anamnesisSeverity: AnamnesisSeverity = rowData.anamnesisSeverity;
    const anamnesisSeverityColor: SemanticCOLORS =
        anamnesisSeverity
            ? ANAMNESIS_SEVERITY_COLORS[anamnesisSeverity] as SemanticCOLORS
            : 'grey';

    const anamnesisSeverityValueText =
        anamnesisSeverity ? getMessage(`enum.AnamnesisSeverity.${anamnesisSeverity}`) : "";
    const anamnesisSeverityTitleText =
        `${getMessage("patientCentral.overview.tableHeader.anamnesisSeverity")}: ${anamnesisSeverityValueText}`;

    const trigger = (
        <span>
          <Icon
              className="anamnesis-severity-icon"
              title={anamnesisSeverityTitleText}
              name="circle"
              fitted
              color={anamnesisSeverityColor}
          />
          {questionSetString}
          <Icon className="anamnesis-details-icon" name="clipboard outline" fitted color="grey"/>
        </span>
    );

    const content = (
        <QuestionSetView
            questionSetName={questionSetString}
            questionAnswerPairs={questionAnswerPairs}
        />
    );

    const loader = (
        <Loader active inline="centered" size="small">{getMessage("loading")}</Loader>
    );

    return (
        <div title={questionSetString}>
          <Popup
              trigger={trigger}
              popperDependencies={[!!questionAnswerPairsLoading]}
              popperModifiers={{
                preventOverflow: {
                  boundary: document.getElementById("patientCentralMainContent")
                }
              }}
              content={questionAnswerPairsLoading ? loader : content}
              flowing
              on="click"
              onOpen={() => this.onAnamnesisInfoColumnClick(rowData.bookingId)}
              onClose={this.clearQuestionAnswerPairState}
              size="large"
              position="right center"
          />
        </div>
    );
  };

  appointmentLocationCellRenderer = (data: any) => {

    const rowData: InterventionBookingSearchResult = data.rowData;
    const locationId = rowData.locationId;

    if (!locationId) {
      return "";
    }

    const resource = this.resourceMap[locationId];
    const displayValue = resource !== undefined ? `${resource.description}` : "";

    return (
        <div>
          <div className="resource" title={displayValue}>{displayValue}</div>
        </div>
    )
  };

  appointmentDateTimeCellRenderer = (data: any) => {

    const {getMessage} = this.props;
    const {rowData} = data;

    const appointmentDate = rowData.appointmentDate;

    if (rowData.status === InterventionBookingStatus.ON_WAIT_LIST) {
      const reminderDate = appointmentDate ? isoToDisplayDate(appointmentDate) : "";
      return (
          <div>
            <div className="date birth-date disabled"
                 title={`${getMessage('patientCentral.patientEntry.appointment.reminderDate')}: ${reminderDate}`}>
              <Icon className="status-icon" fitted name="bell"/>
              {reminderDate}
            </div>
          </div>
      )
    }

    if (!appointmentDate) {
      return "";
    }

    const date = isoToDisplayDate(appointmentDate);
    const time = rowData.appointmentTime;
    const displayValue = time ? `${date} - ${time}` : `${date}`;

    return (
        <div>
          <div className="date birth-date" title={displayValue}>{displayValue}</div>
        </div>
    )
  };

  authorityNotificationStatusCellRenderer = (data: any) => {

    const {getMessage} = this.props;
    const {rowData} = data;

    const status = rowData.authorityNotificationStatus;
    if (!status) {
      return "";
    }

    const displayValue = getMessage(`enum.interventionBookingAuthorityNotificationStatus.${status}`);

    return (
        <div title={displayValue}>
          <div className={`authority-notification-status status-${status}`}>
            {displayValue}
          </div>
        </div>
    )
  };

  testKitCodeCellRenderer = (data: any) => {
    const {cellData} = data;
    if (!cellData) {
      return "";
    }
    return cellData;
  };

  testResultImageRenderer = (testResultImageId: string) => {

    const {getMessage} = this.props;
    const {resultImage, resultImageLoading} = this.state;
    return (
        <EditActionButton
            hoverMessage={getMessage("patientCentral.overview.actions.testResultImage")}
            trigger={<Icon name={'camera'} style={{verticalAlign: "middle"}}/>}
            onConfirm={() => {

              this.setState({
                resultImageLoading: true
              });

              getTestResultImage(testResultImageId, this.state.cancelTokenSource)
                  .then(response => {
                    this.setState({
                      resultImage: response,
                      resultImageLoading: false
                    });
                  })
                  .catch((e) => {
                    this.setState({
                      resultImageLoading: false
                    });
                    this.handleError(e.response.data)
                  });
            }}
        />
        // <TestResultActionButton
        //     poperDependencies={[testResultImageId]}
        //     hoverMessage={getMessage("patientCentral.overview.actions.testResultImage")}
        //     renderContent={
        //       (toggle?: () => void) => <div>
        //         {resultImageLoading
        //             ? <Loader active inline="centered"/>
        //             : resultImage && <img height="200px"
        //                                   src={`data:${resultImage.testResultFileType};base64, ${resultImage.testResultImage}`}
        //                                   alt={getMessage("patientCentral.overview.actions.testResultImage")}/>}
        //         <div className="actions-row">
        //           <Button compact
        //                   style={{marginTop: "1rem"}}
        //                   onClick={() => {
        //                     if (toggle) {
        //                       toggle();
        //                     }
        //                   }}
        //           >
        //             {getMessage("action.back")}
        //           </Button>
        //         </div>
        //       </div>
        //     }
        //     onConfirm={() => {
        //     }}
        //     onOpen={() => {
        //
        //       this.setState({
        //         resultImageLoading: true
        //       });
        //
        //       getTestResultImage(testResultImageId, this.state.cancelTokenSource)
        //           .then(response => {
        //             this.setState({
        //               resultImage: response,
        //               resultImageLoading: false
        //             });
        //           });
        //     }}
        //     trigger={<Icon name={'camera'} style={{verticalAlign: "middle"}}/>}
        // />
    )
  };


  testResultCellRenderer = (data: any) => {

    const {getMessage} = this.props;
    const {rowData, cellData} = data;

    const icons: { [key: string]: { color: SemanticCOLORS } } = {
      [InterventionBookingTestResult.NEGATIVE]: {
        color: "green"
      },
      [InterventionBookingTestResult.POSITIVE]: {
        color: "red"
      },
      [InterventionBookingTestResult.UNCERTAIN]: {
        color: "grey"
      },
      [InterventionBookingTestResult.BORDERLINE]: {
        color: "blue"
      },
      [InterventionBookingTestResult.POOL_POSITIVE]: {
        color: "yellow"
      },
      "VACCINATED": {
        color: "blue"
      },
      "RECOVERED": {
        color: "blue"
      },
      "NEGATIVE_TEST_CERTIFICATE": {
        color: "blue"
      }
    }

    let result = cellData;

    let resultIcon = <></>;
    if (result && result.length > 0) {

      let iconName: SemanticICONS = "circle outline";
      let status = rowData.status;
      if (status === InterventionBookingStatus.COMPLETED) {
        iconName = "check circle"
      } else if (status === InterventionBookingStatus.VERIFIED) {
        iconName = "circle"
      }

      resultIcon = <Icon
          title={getMessage(`enum.testResult.${result}`)}
          name={iconName}
          color={icons[result].color}
          size="large"/>;
    }

    return <>
      {resultIcon}
      {rowData.testResultImageId
          && this.testResultImageRenderer(rowData.testResultImageId)}
    </>;
  };

  renderInterventionBookingHistory = (data: any) => {
    const {rowData} = data;
    const {interventionBookingHistoryLoading, interventionBookingHistory} = this.state;
    const {getMessage} = this.props;

    const trigger = (
        <div className="booking-history-icon-container">
          <div>
            <Icon
                className="booking-history-icon"
                name="history"
                onClick={() => this.onStatusColumnClick(rowData.bookingId)}/>
          </div>
        </div>
    )

    const loader = (
        <Loader active inline="centered" size="small">{getMessage("loading")}</Loader>
    );

    const content =
        interventionBookingHistoryLoading ? loader
            : <BookingHistoryView
                bookingHistory={interventionBookingHistory}
                currentStatus={rowData.status}
                testKitReceptionOptionId={rowData.testKitReceptionOptionId}
            />

    return (
        <span>
      <Popup
          trigger={trigger}
          popperDependencies={[!!interventionBookingHistoryLoading]}
          popperModifiers={{
            preventOverflow: {
              boundary: document.getElementById("patientCentralMainContent")
            }
          }}
          content={content}
          on="click"
          size="small"
          position="left center"
      />
    </span>
    );
  }

  renderCancelSecondDoseModal = () => {

    const {canceledInterventionBookingData, getMessage} = this.props;

    if (canceledInterventionBookingData === undefined) {
      return;
    }

    return <Modal
        open={!!canceledInterventionBookingData}
        onClose={this.closeCancelSecondDoseModal}
        closeOnDimmerClick
    >
      <Modal.Header>
        {getMessage("patientCentral.overview.cancelSecondDose")}
      </Modal.Header>
      <ModalContentContainerSc>
        <StyledPxGrid>
          <Grid.Row>
            <Grid.Column width={16}>
              <Icon name="user"/>&nbsp;
              ({canceledInterventionBookingData.patientId})&nbsp;
              {canceledInterventionBookingData.patientFirstName} {canceledInterventionBookingData.patientLastName}
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column className="with-line-break" width={16}>
              {getMessage("patientCentral.overview.scheduleSecondDose")}
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={16}>
              <Button compact type="button" floated="right" onClick={this.closeCancelSecondDoseModal}>
                {getMessage("button.close")}
              </Button>
            </Grid.Column>
          </Grid.Row>
        </StyledPxGrid>
      </ModalContentContainerSc>
    </Modal>;
  }

  renderAddTestkitCodeModal = () => {
    const {getMessage} = this.props;
    const {addTestkitCodeModalOpen, testkitRegistrationBookingId} = this.state;

    return (
        <Modal
            open={addTestkitCodeModalOpen}
            onClose={() => this.hideAddTestkitCodeModal()}
            closeOnDimmerClick={false}
        >
          <Modal.Header>{getMessage("testKitRegistration.title")}</Modal.Header>
          <FormModalContentContainer>
            <AddTestkitCodeModal
                interventionBookingId={testkitRegistrationBookingId}
                onSave={this.onAddTestkitCode}
                onCancel={this.hideAddTestkitCodeModal}
            />
          </FormModalContentContainer>
        </Modal>
    );
  }

  renderSetTestkitResultModal = () => {
    const {getMessage} = this.props;
    const {testkitSetResultModalOpen, testkitSetResultBooking} = this.state;

    if (!testkitSetResultModalOpen) {
      return <></>;
    }

    return (
        <Modal
            open={testkitSetResultModalOpen}
            onClose={() => this.hideSetTestkitResultModal()}
            closeOnDimmerClick={false}
        >
          <Modal.Header>{getMessage("patientCentral.testKitSetResultModal.title")}</Modal.Header>
          <FormModalContentContainer>
            <SetTestResultModal
                interventionBooking={testkitSetResultBooking}
                onClose={this.hideSetTestkitResultModal}
                onCloseAndUpdate={this.closeSetTestkitResultModalAndUpdateBooking}
            />
          </FormModalContentContainer>
        </Modal>
    );
  }

  renderSetHpvTestkitResultModal = () => {
    const {getMessage} = this.props;
    const {testkitSetHpvResultModalOpen, testkitSetResultBooking} = this.state;

    if (!testkitSetHpvResultModalOpen) {
      return <></>;
    }

    return (
        <Modal
            open={testkitSetHpvResultModalOpen}
            onClose={() => this.hideSetHpvTestkitResultModal()}
            closeOnDimmerClick={false}
        >
          <Modal.Header>{getMessage("patientCentral.testKitSetResultModal.title")}</Modal.Header>
          <FormModalContentContainer>
            <SetTestPanelResultModal
                interventionBooking={testkitSetResultBooking}
                onClose={this.hideSetHpvTestkitResultModal}
                onCloseAndUpdate={this.closeSetHpvTestkitResultModalAndUpdateBooking}
            />
          </FormModalContentContainer>
        </Modal>
    );
  }

  renderSetQuestionTestResultModal = () => {
    const {getMessage} = this.props;
    const {testkitSetQuestionsResultModalOpen, testkitSetResultBooking} = this.state;

    if (!testkitSetQuestionsResultModalOpen) {
      return <></>;
    }

    return (
        <Modal
            open={testkitSetQuestionsResultModalOpen}
            onClose={() => this.hideSetQuestionsTestResultModal()}
            closeOnDimmerClick={false}
        >
          <Modal.Header>{getMessage("patientCentral.testKitSetResultModal.title")}</Modal.Header>
          <FormModalContentContainer>
            <SetQuestionTestResultModal
                interventionBooking={testkitSetResultBooking}
                onClose={this.hideSetQuestionsTestResultModal}
                onCloseAndUpdate={this.closeSetQuestionsTestResultModalAndUpdateBooking}
            />
          </FormModalContentContainer>
        </Modal>
    );
  }

  renderVaccinationTransitionDetailsModal = () => {

    const {getMessage} = this.props;

    const {bookingInTransition, cancelTokenSource} = this.state;

    if (!bookingInTransition) {
      return;
    }

    const _updateBookingStatus = async (bookingId: number,
                                        nextStatus: InterventionBookingStatus,
                                        request: CompleteVaccinationBookingRequestDto) => {

      try {

        let cardPdf = null;
        let certPdf = null;

        let generateCertificateError = null;

        if (request) {

          const response: VaccinationCheckInOutResponse = await checkInOutVaccinationBooking(
              bookingId, request, cancelTokenSource);

          generateCertificateError = response.error;

          if (nextStatus === InterventionBookingStatus.AWAITING_COMPLETION) {
            const vaccinationCard: PdfResponse =
                await vaccinationCardDocument(bookingInTransition.patientId, true, cancelTokenSource);

            if (vaccinationCard && vaccinationCard.pdfId) {
              cardPdf = vaccinationCard;
            }
          } else if (nextStatus === InterventionBookingStatus.COMPLETED && !generateCertificateError) {
            const certificate: PdfResponse =
                await getVaccinationCertificateForBooking(bookingId, cancelTokenSource);

            if (certificate && certificate.pdfId) {
              certPdf = certificate;
            }
          }

          if (cardPdf) {
            await this.openVaccinationCardPdfModal([cardPdf]);
          } else if (certPdf) {
            await this.openVaccinationCertPdfModal([certPdf]);
          }

          if (generateCertificateError) {
            await this.openVaccinationCertificateErrorModal(generateCertificateError);
          }
        }

        await updateBookingStatus(
            bookingId, nextStatus, cancelTokenSource)

        if (!cardPdf && !certPdf && !generateCertificateError) {
          await this.props.onUpdateBookingStatus(bookingId, nextStatus);
        }

      } catch (e) {
        this.handleError(e.response.data);
        this.closeCheckInOutPopup();
      }
    };

    const intervention = this.interventionMap[bookingInTransition.interventionId];
    const interventionString = intervention
        ? `${intervention.description}`
        : "";

    const status = bookingInTransition.status;
    let checkInOut = status === InterventionBookingStatus.PLANNED ? "checkIn" : "checkOut";

    return <Modal
        open={this.state.stateVaccinationTransitionModalOpen}
        onClose={this.closeCheckInOutPopup}
        closeOnDimmerClick={false}
    >
      <Modal.Header>
        {getMessage(`patientCentral.overview.changeStatus.${checkInOut}`)} &nbsp; | &nbsp; {interventionString}
      </Modal.Header>
      <FormModalContentContainer>
        <VaccinationTransitionForm
            interventionMap={this.interventionMap}
            bookingInTransition={bookingInTransition}
            onCheckInOutSave={_updateBookingStatus}
            onCancel={this.closeCheckInOutPopup}
        />
      </FormModalContentContainer>
    </Modal>;
  };

  renderTestTransitionDetailsModal = () => {

    const {getMessage} = this.props;

    const {bookingInTransition} = this.state;

    if (!bookingInTransition) {
      return;
    }

    const _updateBookingStatus = async (bookingId: number, nextStatus: InterventionBookingStatus | undefined) => {

      if (nextStatus) {
        await updateBookingStatus(
            bookingId, nextStatus, this.state.cancelTokenSource);
      }

      this.closeTestCheckInOutPopup();
      this.props.onRefreshBooking(bookingId);
    };

    const _completeVaccination = async (bookingId: number, request: CompleteVaccinationBookingRequestDto) => {

      // await completeVaccinationBooking(
      //     bookingId, request, this.state.cancelTokenSource);

      this.props.onUpdateBookingStatus(bookingId, InterventionBookingStatus.COMPLETED);
    };

    const intervention = this.interventionMap[bookingInTransition.interventionId];
    const interventionString = intervention
        ? `${intervention.description}`
        : "";

    const status = bookingInTransition.status;
    let checkInOut = "checkIn";
    // let checkInOut = status === InterventionBookingStatus.EXECUTED ? "checkIn" : "checkOut";

    return <Modal
        open={this.state.stateTestTransitionModalOpen}
        onClose={this.closeTestCheckInOutPopup}
        closeOnDimmerClick={false}
    >
      <Modal.Header>
        {getMessage(`patientCentral.overview.changeStatus.${checkInOut}`)} &nbsp; | &nbsp; {interventionString}
      </Modal.Header>
      <FormModalContentContainer>
        <TestTransitionForm
            bookingInTransition={bookingInTransition}
            onCheckInSave={_updateBookingStatus}
            onCheckOutSave={_completeVaccination}
            onCancel={this.closeCheckInOutPopup}
        />
      </FormModalContentContainer>
    </Modal>;
  };

  renderPoolTestSingularizationModal = () => {
    const {poolSingularizationId, poolSingularizationModalOpen} = this.state;

    if (!poolSingularizationModalOpen) {
      return <></>;
    }

    return <PoolTestkitSingularization poolTestId={poolSingularizationId}
                                       close={this.hidePoolSingularizationModal}
    />
  };

  setStatusOnHold = async (bookingId: number) => {
    try {
      const nextStatus = await setBookingStatusOnHold(
          bookingId, this.state.cancelTokenSource);

      this.props.onUpdateBookingStatus(bookingId, nextStatus);
    } catch (e) {
      this.handleError(e.response.data);
    }
  }

  revertStatusBeforeOnHold = async (bookingId: number) => {
    try {
      const nextStatus = await revertBookingStatusBeforeOnHold(
          bookingId, this.state.cancelTokenSource);

      this.props.onUpdateBookingStatus(bookingId, nextStatus);
    } catch (e) {
      this.handleError(e.response.data);
    }
  }

  interventionStatusCellRenderer = (data: any) => {

    const {getMessage} = this.props;
    const {rowData} = data;

    const status = rowData.status;
    const displayValue = getMessage(`enum.interventionBookingStatus.${status}`);

    const inputChannel = rowData.inputChannel;

    let icon: SemanticICONS = "calendar alternate";
    switch (status) {
      case "ON_WAIT_LIST":
        icon = "wait";
        break;
      case "PLANNED":
        icon = "calendar alternate";
        break;
      case "COMPLETED":
        icon = "calendar check";
        break;
      case "CANCELLED":
        icon = "calendar times";
        break;
      case "LAB_RECEIVED":
        icon = "lab";
        break;
      case "ON_HOLD":
        icon = "hand paper";
        break;
      case "RESULTED":
        icon = "circle outline";
        break;
      case "VERIFIED":
        icon = "circle";
        break;
    }

    const trigger = (
        <div title={displayValue} className={`intervention-booking-status-container`}>
          <div className={`intervention-booking-status status-${status}`}>
            <Icon className="status-icon" fitted name={icon}/>
            {displayValue}
          </div>
        </div>
    );

    const ensStates = [
      InterventionBookingStatus.COMPLETED,
      InterventionBookingStatus.RESULTED,
      InterventionBookingStatus.VERIFIED,
      InterventionBookingStatus.CANCELLED
    ];
    if (ensStates.includes(status)) {
      return <div>
        {trigger}
        {this.renderInterventionBookingHistory(data)}
      </div>;
    }

    interface StatusTransition {
      prevStates?: InterventionBookingStatus[];
      nextStates?: InterventionBookingStatus[];
      mostLikelyState?: InterventionBookingStatus
      cancelAvailable: boolean;
    }

    const intervention = this.props.getInterventionById(rowData.interventionId);

    let externalCode = InterventionExternalCode.OTHER;
    if (intervention && intervention!.externalCode) {
      // @ts-ignore
      externalCode = intervention!.externalCode;
    }


    const vaccinationCodes = [
      InterventionExternalCode.VACCINATION_DOSE_1,
      InterventionExternalCode.VACCINATION_DOSE_2,
      InterventionExternalCode.VACCINATION_SINGLE_DOSE,
      InterventionExternalCode.VACCINATION_BOOSTER
    ];
    const isVaccination = vaccinationCodes.includes(InterventionExternalCode[externalCode]);
    const isVaccinationDose1 = InterventionExternalCode.VACCINATION_DOSE_1 === externalCode;

    const testCodes = [
      InterventionExternalCode.PCR_SALIVA_TEST,
      //InterventionExternalCode.PCR_SALIVA_TEST_INDIVIDUAL_TEST,
      InterventionExternalCode.RAPID_SALIVA_TEST,
      InterventionExternalCode.HPV_TEST,
      InterventionExternalCode.CHLAMYDIA_TEST,
      InterventionExternalCode.TRICHOMONIASIS_TEST
    ];
    const isTest = testCodes.includes(InterventionExternalCode[externalCode]);
    const isPoolTest = rowData.patientId === 0 && rowData.poolTestId === 0;

    const labTest = intervention && isLabTest(InterventionExternalCode[externalCode]);

    const stateTransitions: { [key: string]: StatusTransition } = {
      [InterventionBookingStatus.REQUESTED]: {
        nextStates: [InterventionBookingStatus.PLANNED],
        mostLikelyState: InterventionBookingStatus.PLANNED,
        cancelAvailable: true
      },
      [InterventionBookingStatus.ON_WAIT_LIST]: {
        prevStates: [InterventionBookingStatus.REQUESTED],
        nextStates: [InterventionBookingStatus.PLANNED],
        mostLikelyState: InterventionBookingStatus.PLANNED,
        cancelAvailable: true
      },
      [InterventionBookingStatus.PLANNED]: {
        prevStates: [InterventionBookingStatus.ON_WAIT_LIST],
        nextStates: isVaccination
            ? [InterventionBookingStatus.AWAITING_COMPLETION]
            : [InterventionBookingStatus.EXECUTED],
        mostLikelyState: InterventionBookingStatus.EXECUTED,
        cancelAvailable: true
      }
    }

    if (!labTest) {
      stateTransitions[InterventionBookingStatus.EXECUTED] = {
        prevStates: [InterventionBookingStatus.PLANNED],
        nextStates: [InterventionBookingStatus.AWAITING_COMPLETION, InterventionBookingStatus.COMPLETED],
        mostLikelyState: InterventionBookingStatus.AWAITING_COMPLETION,
        cancelAvailable: true
      };
      stateTransitions[InterventionBookingStatus.AWAITING_COMPLETION] = {
        prevStates: isVaccination
            ? [InterventionBookingStatus.PLANNED]
            : [InterventionBookingStatus.PLANNED, InterventionBookingStatus.EXECUTED],
        nextStates: [InterventionBookingStatus.COMPLETED],
        mostLikelyState: InterventionBookingStatus.COMPLETED,
        cancelAvailable: true
      };
    } else {
      stateTransitions[InterventionBookingStatus.EXECUTED] = {
        prevStates: [InterventionBookingStatus.PLANNED],
        nextStates: [
          InterventionBookingStatus.AWAITING_COMPLETION,
          InterventionBookingStatus.LAB_RECEIVED,
          InterventionBookingStatus.COMPLETED
        ],
        mostLikelyState: InterventionBookingStatus.AWAITING_COMPLETION,
        cancelAvailable: true
      };
      stateTransitions[InterventionBookingStatus.AWAITING_COMPLETION] = {
        prevStates: [InterventionBookingStatus.PLANNED, InterventionBookingStatus.EXECUTED],
        nextStates: [InterventionBookingStatus.LAB_RECEIVED, InterventionBookingStatus.COMPLETED],
        mostLikelyState: InterventionBookingStatus.LAB_RECEIVED,
        cancelAvailable: true
      };
      stateTransitions[InterventionBookingStatus.LAB_RECEIVED] = {
        prevStates: [InterventionBookingStatus.AWAITING_COMPLETION],
        nextStates: [InterventionBookingStatus.COMPLETED],
        mostLikelyState: InterventionBookingStatus.COMPLETED,
        cancelAvailable: true
      };
    }

    if (isTest) {
      stateTransitions[InterventionBookingStatus.ON_HOLD] = {
        prevStates: [InterventionBookingStatus.LAB_RECEIVED],
        nextStates: [InterventionBookingStatus.RESULTED],
        mostLikelyState: InterventionBookingStatus.LAB_RECEIVED,
        cancelAvailable: true
      };
    }

    const bookingId = rowData.bookingId;
    const _updateBookingStatus = async (nextStatus: InterventionBookingStatus) => {

      const vaccinationDetailedTransitionStates = [
        InterventionBookingStatus.PLANNED, InterventionBookingStatus.AWAITING_COMPLETION];
      const vaccinationNonDetailedTransitionStates = [
        InterventionBookingStatus.ON_WAIT_LIST, InterventionBookingStatus.CANCELLED];

      const testDetailedTransitionStates = [InterventionBookingStatus.EXECUTED];
      const testNonDetailedTransitionStates = [
        InterventionBookingStatus.ON_WAIT_LIST,
        InterventionBookingStatus.PLANNED,
        InterventionBookingStatus.CANCELLED];

      if (isVaccination
          && vaccinationDetailedTransitionStates.includes(status)
          && !vaccinationNonDetailedTransitionStates.includes(nextStatus)) {

        this.setState({
          bookingInTransition: rowData,
          statusChangePopupOpen: undefined,
          stateVaccinationTransitionModalOpen: true
        });
      } else if (isTest
          && !isPoolTest
          && testDetailedTransitionStates.includes(status)
          && !testNonDetailedTransitionStates.includes(nextStatus)) {
        this.showTestCheckInModal(rowData);
      } else {

        await updateBookingStatus(
            bookingId, nextStatus, this.state.cancelTokenSource);

        this.props.onUpdateBookingStatus(bookingId, nextStatus);

        const isVaccinationDose2 = InterventionExternalCode.VACCINATION_DOSE_2 === externalCode;
        const canceledSecondDose = nextStatus === InterventionBookingStatus.CANCELLED;

        if (isVaccinationDose2 && canceledSecondDose) {
          this.props.setCanceledInterventionBookingData(rowData);
        }
      }
    };

    let stateTransition = stateTransitions[status];
    if (!stateTransition) {
      stateTransition = {
        prevStates: [],
        nextStates: [],
        mostLikelyState: status,
        cancelAvailable: false
      }
    }

    const statusPrefix = isVaccinationDose1
        ? "enum.interventionBookingStatusVaccination1"
        : "enum.interventionBookingStatus";

    const content = (
        <StateTransitionDiv>
          <div className="info">
            {getMessage("patientCentral.overview.changeStatus.changeStatusTo")}
          </div>
          {
              stateTransition.prevStates &&
              stateTransition.prevStates.map(transition => <Button
                  key={`to-${transition}`}
                  onClick={() => _updateBookingStatus(transition)}
                  type="button"
                  basic
                  className={`${transition === stateTransition.mostLikelyState ? "most-likely-next-state" : ""}`}
              >
                <Icon name="angle up"/>
                {getMessage(`${statusPrefix}.${transition}`)}
              </Button>)
          }
          <div>
            <Button
                type="button"
                basic
                disabled
                className={`current-state`}
            >
              <Icon name="caret right"/>
              {getMessage(`${statusPrefix}.${status}`)}
            </Button>
          </div>
          {
              stateTransition.nextStates &&
              stateTransition.nextStates.map(transition => <Button
                  key={`to-${transition}`}
                  onClick={() => _updateBookingStatus(transition)}
                  type="button"
                  basic
                  className={`${transition === stateTransition.mostLikelyState ? "most-likely-next-state" : ""}`}
              >
                <Icon name="angle down"/>
                {getMessage(`${statusPrefix}.${transition}`)}
              </Button>)
          }
          {
              stateTransition.cancelAvailable &&
              <div className="cancel-box">
                <Button
                    onClick={() => _updateBookingStatus(InterventionBookingStatus.CANCELLED)}
                    type="button"
                    basic
                    className="cancel-button"
                >
                  <Icon name="cancel"/>
                  {getMessage(`${statusPrefix}.${InterventionBookingStatus.CANCELLED}`)}
                </Button>
              </div>
          }
        </StateTransitionDiv>
    );

    return <div>
      <Popup
          trigger={trigger}
          content={content}
          on="click"
          size="small"
          position="left center"
          open={bookingId === this.state.statusChangePopupOpen}
          onOpen={() => {
            this.setState({
              statusChangePopupOpen: rowData.bookingId
            });
          }}
          onClose={() => {
            this.setState({
              statusChangePopupOpen: undefined
            });
          }}
      />
      {this.renderInterventionBookingHistory(data)}
    </div>
  };

  renderPrintLabelPopup = (patientId: number) => {
    const {getMessage} = this.props;
    const {printLabelPopupOpen} = this.state;

    return (
        <TestResultActionButton
            poperDependencies={[printLabelPopupOpen]}
            renderContent={(toggle?: () => void) => this.printLabelPopupContent(toggle)}
            hoverMessage={getMessage("patient.toolbar.praxMedicNativeTools")}
            onConfirm={() => {
            }}
            onOpen={() => this.triggerFastPrintPatientDocuments(patientId)}
            trigger={<Icon name={'print'}/>}
        />
    );
  }

  renderInvoiceIcon = (rowData: InterventionTestBookingSearchResult, isInterventionInvoiced: boolean) => {

    const {productMap, options, getMessage} = this.props;

    const bookingId = rowData.bookingId;
    const treaterId = options.currentTreater.id;

    let productId = rowData.productId;
    const isFreeProduct = this.isFreeProduct(productId);

    return (
        isInterventionInvoiced !== undefined && !isInterventionInvoiced && !isFreeProduct &&
        <InvoiceActionButton
            hoverMessage={getMessage('msgInvoice')}
            disabled={false}
            popupMessage={getMessage("patientCentral.tableData.intervention.confirmInvoicing")}
            onConfirm={() => this.onInvoiceInterventionClick(bookingId, treaterId)}
        />
    );
  }

  isFreeProduct = (productId?: string): boolean => {
    const {productMap} = this.props;

    let product = productId ? productMap[productId] : undefined;

    const isFreeProduct = product ? product.freeProduct : true;
    return isFreeProduct;
  }

  renderDeleteInvoiceIcon = (rowData: InterventionTestBookingSearchResult, isInterventionInvoiced: boolean) => {

    const {getMessage} = this.props;

    const bookingId = rowData.bookingId;

    let productId = rowData.productId;
    const isFreeProduct = this.isFreeProduct(productId);

    return (
        isInterventionInvoiced && !isFreeProduct &&
        <InvoiceActionButton
            hoverMessage={getMessage('msgDeleteInvoice')}
            trigger={
              <Icon.Group size="small">
                <Icon name="money bill alternate outline"/>
                <Icon corner="top right" name="delete" color="grey"/>
              </Icon.Group>
            }
            disabled={false}
            popupMessage={getMessage("patientCentral.tableData.intervention.confirmDeleteInvoice")}
            onConfirm={() => this.onDeleteInterventionInvoiceClick(bookingId)}
        />
    );
  }

  rowActionsCellRenderer = (data: any) => {

    const {rowData} = data;
    const {getMessage} = this.props;
    const {qrcodeb64, testRegistrationUrl, qrcodeVisible} = this.state;

    const searchBy = this.props.bookingSearchRequest.searchBy;
    const isTestSearch = searchBy === InterventionBookingSearchBy.COVID_TEST;
    const isVaccinationSearch = searchBy === InterventionBookingSearchBy.VACCINATION;

    const actionEnabled =
        rowData.status === InterventionBookingStatus.PLANNED
        || rowData.status === InterventionBookingStatus.ON_WAIT_LIST;

    const changeControlledByStatusEnabled =
        this.props.currentUserHasPrivilege(Privilege.PX_CORE_SET_CONTROLLED_BY_STATUS)
        && (rowData.status === InterventionBookingStatus.VERIFIED);

    const checkInEnabled = this.props.currentUserHasPrivilege(Privilege.PX_CORE_TEST_CHECK_IN)
        && (rowData.status === InterventionBookingStatus.PLANNED
            || rowData.status === InterventionBookingStatus.EXECUTED
            || (rowData.status === InterventionBookingStatus.AWAITING_COMPLETION && !isTestSearch));

    const checkInOutVacEnabled = isVaccinationSearch
        && this.props.currentUserHasPrivilege(Privilege.PX_CORE_TEST_CHECK_IN)
        && (rowData.status === InterventionBookingStatus.PLANNED
            || rowData.status === InterventionBookingStatus.EXECUTED
            || rowData.status === InterventionBookingStatus.AWAITING_COMPLETION);

    const setTestResultPrivilege = rowData.testResult === null
        && this.props.currentUserHasPrivilege(Privilege.PX_CORE_SET_TEST_RESULT);

    const verifyTestPrivilege = rowData.testResult
        && this.props.currentUserHasPrivilege(Privilege.PX_CORE_VERIFY_TEST_RESULT);

    const isInterventionInvoiced = rowData.status === InterventionBookingStatus.COMPLETED && rowData.productId !== null
        ? rowData.invoiced : undefined;

    let resendEmailEnabled = this.props.currentUserHasPrivilege(Privilege.PX_CORE_SET_CONTROLLED_BY_STATUS)
        && (rowData.status === InterventionBookingStatus.COMPLETED
            || rowData.status === InterventionBookingStatus.CONTROLLED_BY);

    if (!isTestSearch) {

      const renderTarget = (
          <div>
            {
                checkInOutVacEnabled &&
                <TestResultActionButton
                    hoverMessage={
                      rowData.status === InterventionBookingStatus.AWAITING_COMPLETION
                          ? getMessage("patientCentral.overview.actions.checkOut")
                          : getMessage("patientCentral.overview.actions.checkIn")
                    }
                    trigger={<Icon name="street view"/>}
                    onConfirm={() => this.showCheckInOutPopup(rowData)}
                />
            }
            {
                actionEnabled &&
                <EditActionButton
                    hoverMessage={getMessage('msgEdit')}
                    onConfirm={() => this.props.onEditBooking(rowData.bookingId)}
                />
            }
            <AddActionButton
                hoverMessage={getMessage('button.add')}
                onConfirm={() => this.props.onAddNewChildBooking(rowData.bookingId)}
            />
            {rowData.patientId ? this.renderPrintLabelPopup(rowData.patientId) : null}

          </div>
      );
      return renderTarget;
    } else {
      const interventionId = rowData.interventionId;
      const intervention = this.props.getInterventionById(interventionId);
      const interventionExternalCode = intervention!.externalCode;

      resendEmailEnabled = resendEmailEnabled && (!intervention || !intervention.suppressPatientEmail);

      const pcrTest = interventionExternalCode === InterventionExternalCode.PCR_SALIVA_TEST
          || interventionExternalCode === InterventionExternalCode.PCR_SALIVA_TEST_INDIVIDUAL_TEST;
      const rapidTest = interventionExternalCode === InterventionExternalCode.RAPID_SALIVA_TEST;
      const questionTest = interventionExternalCode === InterventionExternalCode.CLINICAL_QUESTIONS_TEST;
      const rsvTest = interventionExternalCode === InterventionExternalCode.RSV_TEST;
      const influenzaTest = interventionExternalCode === InterventionExternalCode.INFLUENZA_TEST;
      const hepatitisBTest = interventionExternalCode === InterventionExternalCode.HEPATITIS_B_TEST;
      const labTest = isLabTest(InterventionExternalCode[interventionExternalCode]);
      const testKitCodeOptional = isTestKitCodeOptional(InterventionExternalCode[interventionExternalCode]);
      const testPanel = isTestPanel(InterventionExternalCode[interventionExternalCode]);
      const poolMember = rowData.poolTestId && rowData.poolTestId > 0;

      const setImageTest = pcrTest || rsvTest || influenzaTest || hepatitisBTest;

      const b64background = `url('data:image/png;base64,${qrcodeb64}')`;

      return <div>
        {
            changeControlledByStatusEnabled &&
            <SetControlledByStatusActionButton
                hoverMessage={getMessage("patientCentral.overview.actions.setControlledByStatus")}
                onConfirm={() => {
                  if (pcrTest || rapidTest) {
                    this.showSetTestkitResultModal(rowData);
                  }

                  if (testPanel) {
                    this.showSetTestPanelResultModal(rowData);
                  }

                  if (questionTest) {
                    this.showSetQuestionsTestResultModal(rowData);
                  }
                }
                }
            />
        }
        {
          rowData.patientId && rowData.patientId > 0 && checkInEnabled
              ? <TestResultActionButton
                  hoverMessage={getMessage("patientCentral.overview.actions.checkIn")}
                  trigger={<Icon name="street view"/>}
                  onConfirm={() => this.showTestCheckInModal(rowData)}
              />
              : <></>
        }

        {/*{
          pcrTest && !rowData.testKitCode &&
          <Icon name="barcode" onClick={() => this.showAddTestkitCodeModal(rowData.bookingId)}/>
        }*/}

        {
            !poolMember
            && (rapidTest
                || (setImageTest && InterventionBookingStatus.LAB_RECEIVED === rowData.status))
            && rowData.testResult === null
            && InterventionBookingStatus.CANCELLED !== rowData.status
            && this.props.currentUserHasPrivilege(Privilege.PX_CORE_SET_TEST_RESULT)
            && <>
              <QrcodeActionButton
                  poperDependencies={[qrcodeVisible]}
                  popperModifiers={{
                    preventOverflow: {
                      boundary: document.getElementById("patientCentralMainContent")
                    }
                  }}
                  renderContent={
                    (toggle?: () => void) => <QrContentDiv>
                      <div className="employee-data">
                        {`${rowData.patientFirstName} ${rowData.patientLastName}, ${isoToDisplayDate(rowData.patientBirthDate)}`}
                      </div>
                      {
                        qrcodeVisible
                            ? <a target="_blank"
                                 rel="noreferrer"
                                 href={testRegistrationUrl}
                                 title={getMessage("covidTestkitSnapshot.action.takeSnapshot")}>
                              <div className="qrcode-wrapper">
                                <div className="qrcode" style={{
                                  backgroundImage: b64background
                                }}>
                                  &nbsp;
                                </div>
                              </div>
                            </a>
                            :
                            <div>
                              <Loader active inline/>
                            </div>
                      }
                      <div className="actions-row">
                        <Button compact size="mini" onClick={() => {
                          if (toggle) {
                            toggle();
                          }
                          this.props.onRefreshBooking(rowData.bookingId);
                        }}
                        >
                          {getMessage("button.close")}
                        </Button>
                      </div>
                      <div className="link-info">
                        <Icon name="info circle"/>
                        {getMessage("rapidTestkitSnapshot.qrcode.linkInfo")}
                      </div>
                    </QrContentDiv>
                  }
                  onConfirm={() => {
                  }}
                  onOpen={() => {

                    this.setState({
                      qrcodeVisible: false
                    });

                    const request: PraxTestRegistrationQrCodeRequest = {
                      bookingId: rowData.bookingId,
                      baseUrl: ""
                    };

                    if (pcrTest || rapidTest) {
                      createCovidTestkitQrcodeBase64String(request, this.state.cancelTokenSource)
                          .then(response => {
                            this.setState({
                              qrcodeb64: response.imageB64,
                              testRegistrationUrl: response.url,
                              qrcodeVisible: true
                            });
                          });
                    } else {
                      createPanelTestkitQrcodeBase64String(request, this.state.cancelTokenSource)
                          .then(response => {
                            this.setState({
                              qrcodeb64: response.imageB64,
                              testRegistrationUrl: response.url,
                              qrcodeVisible: true
                            });
                          });
                    }
                  }}
                  position="left center"
                  hoverMessage={getMessage("patientCentral.overview.actions.setTestResult")}
                  trigger={
                    <Icon name={'camera'} color="grey"/>
                  }
              />
            </>
        }

        {
            (!poolMember
                && ((!rapidTest && !labTest && InterventionBookingStatus.CANCELLED !== rowData.status)
                    || (labTest
                        && (testKitCodeOptional || rowData.testKitCode !== null)
                        && [
                          InterventionBookingStatus.RESULTED,
                          InterventionBookingStatus.LAB_RECEIVED
                        ].includes(rowData.status))
                    || ((questionTest || rapidTest)
                        && [
                          InterventionBookingStatus.RESULTED,
                          InterventionBookingStatus.AWAITING_COMPLETION
                        ].includes(rowData.status))
                    || (rapidTest
                        && [
                          InterventionBookingStatus.RESULTED,
                          InterventionBookingStatus.VERIFIED,
                          InterventionBookingStatus.AWAITING_COMPLETION
                        ].includes(rowData.status))
                ))
            && (verifyTestPrivilege || setTestResultPrivilege)
            && <TestResultActionButton
                hoverMessage={getMessage("patientCentral.overview.actions.setTestResult")}
                trigger={<Icon name={'flask'}/>}
                onConfirm={() => {
                  if (pcrTest || rapidTest) {
                    this.showSetTestkitResultModal(rowData)
                  }

                  if (testPanel) {
                    this.showSetTestPanelResultModal(rowData)
                  }

                  if (questionTest) {
                    this.showSetQuestionsTestResultModal(rowData);
                  }
                }
                }
            />
        }

        {
            (!poolMember
                && (((!rapidTest && !questionTest && !labTest)
                        && InterventionBookingStatus.CANCELLED !== rowData.status)
                    || (labTest
                        && (testKitCodeOptional || rowData.testKitCode !== null)
                        && !rowData.testResultVerified
                        && [
                          InterventionBookingStatus.ON_HOLD,
                          InterventionBookingStatus.LAB_RECEIVED,
                          InterventionBookingStatus.RESULTED
                        ].includes(rowData.status))
                    || ((questionTest || rapidTest) && !rowData.testResultVerified
                        && [
                          InterventionBookingStatus.ON_HOLD,
                          InterventionBookingStatus.RESULTED
                        ].includes(rowData.status))))
            && (verifyTestPrivilege || setTestResultPrivilege)
            && <TestResultActionButton
                hoverMessage={
                  rowData.status === InterventionBookingStatus.ON_HOLD
                      ? getMessage("patientCentral.overview.actions.release")
                      : getMessage("patientCentral.overview.actions.setOnHold")
                }
                trigger={
                  rowData.status === InterventionBookingStatus.ON_HOLD
                      ? <Icon name={'hand point right'}/>
                      : <Icon name={'hand paper'}/>
                }
                onConfirm={
                  rowData.status === InterventionBookingStatus.ON_HOLD
                      ? () => this.revertStatusBeforeOnHold(rowData.bookingId)
                      : () => this.setStatusOnHold(rowData.bookingId)
                }
            />
        }

        {
            ((!poolMember && rowData.testResult)
                || (questionTest && rowData.status === InterventionBookingStatus.COMPLETED)) &&
            <DeleteActionButton
                hoverMessage={getMessage('patientCentral.overview.actions.clearTestResult')}
                popupMessage={getMessage("patientCentral.overview.actions.confirmClearTestRest")}
                trigger={<Icon name={'erase'}/>}
                onConfirm={() => this.props.onClearBookingTestResult(rowData.bookingId)}
            />
        }

        {
            (!rowData.patientId && rowData.testResult === InterventionBookingTestResult.POSITIVE) &&
            <Icon name={'sitemap'}
                  style={rowData.poolSingularized ? {color: "green"} : {color: "orange"}}
            />
          /*<TestResultActionButton
              hoverMessage={getMessage("patientCentral.overview.actions.singularize")}
              trigger={
                <Icon name={'sitemap'}
                      style={rowData.poolSingularized ? {color: "green"} : {}}
                />
              }
              onConfirm={() => {
                this.showPoolSingularizationModal(rowData.testId)
              }}
          />*/
        }

        {
            resendEmailEnabled
            && <ResendTestResultEmailActionButton
                hoverMessage={getMessage("patientCentral.overview.actions.resendEmail")}
                popupMessage={getMessage("patientCentral.overview.actions.confirmResendEmail")}
                onConfirm={() => this.resendTestResultEmail(rowData.bookingId)}/>
        }

        {rowData.patientId ? this.renderPrintLabelPopup(rowData.patientId) : null}
        {!isInterventionInvoiced ? this.renderInvoiceIcon(rowData, isInterventionInvoiced) : null}
        {isInterventionInvoiced ? this.renderDeleteInvoiceIcon(rowData, isInterventionInvoiced) : null}
      </div>
    }

  };

}

export default withMessages(
    withAuthContext(
        withRouterWorkaround(
            withMandateContext(
                withPatientCentralRefDataContext(
                    withPatientCentralContext(InterventionBookingsTableView))))));
